/**
 * package: com.inq.flash.client.chatskins
 * class: SkinControl
 * root Object
 */
com.inq.flash.client.chatskins.SkinControl = {};
/** @private @type {string} */
com.inq.flash.client.chatskins.SkinControl.inqPersistentUrl = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.SkinControl.sPopCID = null;
/** @private @type {string} */
com.inq.flash.client.chatskins.SkinControl.sPerCID = null;
/** @private @type {com.inq.flash.client.control.ApplicationController} */
com.inq.flash.client.chatskins.SkinControl.applicationController = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.connectionType = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptAgentColor = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptCustomerColor = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptFontSize = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptIndent = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptTabStops = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptFont = null;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.transcriptAgentSample = null;
/** @type {Number} to keep interval id of chat window closing warning */
com.inq.flash.client.chatskins.SkinControl.warningEvery2minId = -1;
/** @type {Number} to keep timeout id of last 30 sec warning */
com.inq.flash.client.chatskins.SkinControl.warninglast30secId = null;
// Variables to save timer's parameters
com.inq.flash.client.chatskins.SkinControl.timeoutTime = null;
com.inq.flash.client.chatskins.SkinControl.timeoutAction = null;
// Flag to indicate that an opener script has an element that will claim the initial focus
com.inq.flash.client.chatskins.SkinControl.initialFocusClaimedBy = null;
/** @type {boolean} flag that chat session is ended */
com.inq.flash.client.chatskins.SkinControl.chatSessionEnded = false;

/**
 * Adds openers to transcript window
 * Used as callback for conversation transcript request
 */
com.inq.flash.client.chatskins.SkinControl.showOpenerScripts = function() {
	if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().isAsyncChat()
		&& com.inq.flash.client.chatskins.SkinControl.hasLastConversationMessages
		&& (com.inq.flash.client.chatskins.SkinControl.conversationActive
			|| !com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().showOpenerForEndedConversation)
	) {
		return;
	}
	/* AddToChatWindow("UnknownNameAtThisPoint", "Where is the opening script retrieved from?", ChatTextArea.AGENT); */
	com.inq.flash.client.chatskins.SkinControl.openerScript = new com.inq.flash.client.chatskins.OpenerScript();
	if (com.inq.flash.client.chatskins.SkinControl.bChatIsVisible) {
		com.inq.flash.client.chatskins.SkinControl.openerScript.start();
	}
};

/**
 * Parsing last conversation transcript data and insert into chat transcript
 * @param {Object|String} response transcript data in JSON or stringified JSON format
 * @throws If no messages received of malformed JSON in response
 * @return {boolean} true if any messages were successfully inserted in transcript window otherwise false
 */
com.inq.flash.client.chatskins.SkinControl.parseConversationTranscript = function (response) {
	/** @type {string|Object} */
	var jsonResponse = typeof response == 'string' ? JSON.parse(response) : response;
	/** @type {Object} */
	var responseData = typeof jsonResponse.data == 'string' ? JSON.parse(jsonResponse.data) : jsonResponse.data;

	/** @type {boolean} */
	var transcriptInserted = false;
	if (responseData.conversations) {
		transcriptInserted = parseAllConversationTranscript(responseData.conversations);
	} else {
		com.inq.flash.client.chatskins.SkinControl.topicId = responseData.topicID;
		com.inq.flash.client.chatskins.SkinControl.topicName = responseData.topicName;
		com.inq.flash.client.chatskins.SkinControl.conversationActive = responseData.outcome === "active" || responseData.outcome === "followup";
		if (com.inq.flash.client.chatskins.SkinControl.conversationActive) {
			var initialConversationCustomerID = responseData.customerID;
			if (initialConversationCustomerID) {
				com.inq.flash.client.control.PersistenceManager.SetValue(INITIAL_CUSTOMER_ID, initialConversationCustomerID);
			}
			var conversationID = responseData.conversationID;
			if (conversationID) {
				com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationID);
			}
		}
		transcriptInserted = parseConversationTranscript(responseData, true);
	}
	com.inq.flash.client.chatskins.SkinControl.getChatWindow().render();
	return transcriptInserted;

	function parseAllConversationTranscript(conversations) {
		if (conversations && conversations.length > 0) {
			for (var i = 0; i < conversations.length; i++) {
				var conversationData = conversations[i];
				com.inq.flash.client.chatskins.SkinControl.topicId = conversationData.topicID;
				com.inq.flash.client.chatskins.SkinControl.topicName = conversationData.topicName;
				com.inq.flash.client.chatskins.SkinControl.conversationActive = conversationData.outcome === "active" || conversationData.outcome === "followup";
				parseConversationTranscript(conversationData, i === conversations.length - 1);
				if (!com.inq.flash.client.chatskins.SkinControl.conversationActive) {
					com.inq.flash.client.chatskins.SkinControl.addConversationSeparator();
				}
			}
			if (com.inq.flash.client.chatskins.SkinControl.conversationActive) {
				var initialConversationCustomerID = responseData.customerID;
				if (initialConversationCustomerID) {
					com.inq.flash.client.control.PersistenceManager.SetValue(INITIAL_CUSTOMER_ID, initialConversationCustomerID);
				}
				var conversationID = conversations[conversations.length - 1].conversationID;
				if (conversationID) {
					com.inq.flash.client.control.PersistenceManager.SetValue(CONVERSATION_ID, conversationID);
				}
			}
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Parses conversation transcript. Returns true if at least one message was processed
	 * @param {Object} responseData Conversation data
	 * @param {boolean} isLatestConversation Indicates if conversation is latest or not
	 * @return {boolean}
	 */
	function parseConversationTranscript(responseData, isLatestConversation) {
		var messages = responseData.messages;
		com.inq.flash.client.chatskins.SkinControl.hasLastConversationMessages = messages && messages.length && isLatestConversation;

		if (messages && messages.length > 0) {
			var chatActive = false;
			var activeChatId = getActiveChatId(messages, isLatestConversation);

			for (var i = 0; i < messages.length; i++) {
				var message = messages[i];

				// sub_header shouldn't be added to transcript
				if (message.messageType === "sub_header") {
					if (message.engagementID === activeChatId) {
						chatActive = true;
					}
					continue;
				}

				// in case if ABC messages are present in transcript need to hide them if this setting is true
				if (com.inq.flash.client.control.FlashPeer.isHideJsonTranscriptMessages()) {
					try {
						var parsedMessageText = JSON.parse(message["messageText"]);
						if (typeof parsedMessageText === "object") {
							continue;
						}
					} catch (e) {
						// not JSON continue processing
					}
				}
				var messageTimestamp;
				var timestampInMilliseconds = parseInt(message.timestamp);
				if (!isNaN(timestampInMilliseconds)) {
					messageTimestamp = new Date(timestampInMilliseconds);
				}
				var msgAlias = message["agent.alias"] || message["customerAlias"] || com.inq.flash.client.control.FlashVars.getCustomerName();
				var chatTextArea = message["agent.alias"] ? com.inq.flash.client.chatskins.ChatTextArea.AGENT : com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER;

				/*
				 * After click on c2c for async chat all transcript including active chat
				 * transcript will be took from TS (RTM + solar).
				 * But then after reconnect all active chat messages will be gotten from CR,
				 * and active chat id will be excluded from transcript request to TS.
				 * After reconnect ChatTextArea#arrayTranscripts will be cleaned,
				 * but CR doesn't save openers, so opener messages should be saved in
				 * ChatTextArea#arrayOpeners it will help to prevent clearing it.
				 */
				if (message["agentID"] === "_opener_" && chatActive) {
					com.inq.flash.client.chatskins.SkinControl.AddOpenerToChatWindow(
						msgAlias,
						message.messageText,
						chatTextArea,
						-1,
						null,
						messageTimestamp
					);
				} else {
					com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
						msgAlias,
						message.messageText,
						chatTextArea,
						-1,
						null,
						"1",
						"",
						messageTimestamp,
						!chatActive
					);
				}
			}
			parseAsyncSurvey(responseData.surveyAlias, responseData.surveyMessage, responseData.conversationID, messageTimestamp);
			return true;
		} else {
			return false;
		}
	}

	/**
	 * Parses async survey message and adds to chat transcript
	 *
	 * @param {string} asyncSurveyAlias
	 * @param {string} asyncSurveyMessage
	 * @param {string} conversationID
	 * @param {Date} messageTimestamp - timestamp of message before survey.
	 *                                  We need this parameter to show actual new day.
	 *                                  Take a look RTDEV-31905
	 */
	function parseAsyncSurvey(asyncSurveyAlias, asyncSurveyMessage, conversationID, messageTimestamp) {
		if (asyncSurveyMessage && typeof asyncSurveyMessage === "string") {
			// async survey message must be formatted initially. <a href="{url}">{url} OR message</a>
			asyncSurveyMessage = com.inq.flash.client.chatskins.SkinControl.prepareAsyncSurveyMessage(asyncSurveyMessage, conversationID);
			com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
				asyncSurveyAlias ? asyncSurveyAlias : "",
				asyncSurveyMessage,
				com.inq.flash.client.chatskins.ChatTextArea.SYSTEM_INFO,
				-1,
				null,
				"",
				null,
				messageTimestamp,
				true
			);
		}
	}

	/**
	 * Find last engagement id in transcript.
	 *
	 * @param {Array} messages - conversation massages
	 * @param {boolean} isLatestConversation - indicates if conversation is latest or not
	 *
	 * @return {?string} last engagement id
	 */
	function getActiveChatId(messages, isLatestConversation) {
		if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().isAsyncReconnect()
			&& isLatestConversation
		) {
			for (var i = messages.length - 1; i >= 0; i--) {
				var message = messages[i];

				if (message.messageType === "sub_header") {
					return message.engagementID;
				}
			}
		}

		return null;
	}
};

/**
 * Prepares the received survey message text for display in the chat window,
 * changing the message text according to the template.
 *
 * @param {string} messageText
 * @param {string=} conversationID
 * @returns {string}
 */
com.inq.flash.client.chatskins.SkinControl.prepareAsyncSurveyMessage = function (messageText, conversationID) {
	if (com.inq.flash.client.chatskins.SkinControl.NATIVE_POST_CHAT_SURVEY_REGEXP.test(messageText)) {
		conversationID = conversationID ? conversationID : "";
		messageText = messageText.replace(/href=(?:"|')(.+?)(?:"|')/, function (str, url) {
			/** @type {string} */
			var surveyURL = url + "&conversationID=" + conversationID;
			return 'href="#" ' + com.inq.flash.client.chatskins.SkinControl.DATA_SURVEY_URL + '="' + surveyURL + '"';
		});
	}

	return messageText;
};

/**
 * getOpener
 *
 * $type TFun([],TDynamic(null))
 * public static function getOpener():Dynamic
 * @public
 * @static
 * @return {null}
 */
com.inq.flash.client.chatskins.SkinControl.getOpener = function() {
	/** @type {Window} */
	var opener = null;
	try {
		if (com.inq.flash.client.chatskins.SkinControl.isClick2WebCall() || com.inq.flash.client.control.WebRTCMgr.isEngaged) {
			opener = window;
		}
		else {
			opener = window.parent.opener["inqFrame"];
		}
	} catch( e ) {
		haxe.Log.trace("SkinControl.getOpener Error " + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 124, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "getOpener", customParams : ["error"]});
	}
	return opener;
};


/**
 * StopTimer
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function StopTimer():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.StopTimer = function() {
	if(com.inq.flash.client.chatskins.SkinControl.timerTimeout != null) {
		com.inq.flash.client.chatskins.SkinControl.timerTimeout.stop();
		com.inq.flash.client.chatskins.SkinControl.timerTimeout = null;
		com.inq.flash.client.chatskins.SkinControl.stopWarning();
	}
};


/**
 * stopOpenerScript
 * stop openerScript
 *
 * $type TFun([{ name => bForce, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function stopOpenerScript(?bForce:Bool = false):Void
 * @public
 * @static
 * @param {boolean}  bForce
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.stopOpenerScript = function(bForce) {
	if(bForce == null) bForce = false;
	if(com.inq.flash.client.chatskins.SkinControl.openerScript != null) {
		haxe.Log.trace("stop OpenerScript",{ fileName : "SkinControl.hx", lineNumber : 141, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "stopOpenerScript"});
		com.inq.flash.client.chatskins.SkinControl.openerScript.stop(bForce);
	}
};

/**
 * getApplicationController
 *
 * $type TFun([],TInst(com.inq.flash.client.control.ApplicationController,[]))
 * public static function getApplicationController():ApplicationController
 * @public
 * @static
 * @return {com.inq.flash.client.control.ApplicationController}
 */
com.inq.flash.client.chatskins.SkinControl.getApplicationController = function() {
	return com.inq.flash.client.chatskins.SkinControl.applicationController;
};


/**
 * SkinResize
 *
 * $type TFun([{ name => data, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function SkinResize(data:Dynamic):Bool
 * @private
 * @static
 * @param {null}  data
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.SkinResize = function(data) {
	try {
		/* trace("I resized") ; */
		Application.application.setWidth(Application.application.screen.getWidth());
		Application.application.setHeight(Application.application.screen.getHeight());
	} catch( err ) {
		if( js.Boot.__instanceof(err,Error) ) {
		} else throw(err);
	}
	return true;
};


/**
 * applyTranscriptToPersistent
 *
 * $type TFun([{ name => sHtml, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function applyTranscriptToPersistent(sHtml:String):Void
 * @public
 * @static
 * @param {string}  sHtml
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.applyTranscriptToPersistent = function(sHtml) {
	com.inq.flash.client.chatskins.SkinControl.cw.setHtmlText(sHtml);
};


/**
 * setSocketIP
 *
 * $type TFun([{ name => crAddress, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function setSocketIP(crAddress:String):Void
 * @public
 * @static
 * @param {string}  crAddress
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setSocketIP = function(crAddress) {
	com.inq.flash.client.chatskins.SkinControl.sSocketIP = crAddress;
};
/*
 * addWebRTCToStream
 * @return {String}
 */
com.inq.flash.client.chatskins.SkinControl.addWebRTCToStream = function () {
	if(!com.inq.utils.Util.getConfig("WebRTCEnabled", false)) {
		return "";
	}
	var sep = "^^";
	var rtc = com.inq.flash.client.control.WebRTCMgr.isWebRTCCapable();
	return com.inq.flash.client.chatskins.SkinControl.CSDL_WEBRTC_CAP + rtc + sep;
};

/**
 * setApplicationController
 *
 * $type TFun([{ name => controller, t => TInst(com.inq.flash.client.control.ApplicationController,[]), opt => false }],TEnum(Void,[]))
 * public static function setApplicationController(controller: ApplicationController):Void
 * @public
 * @static
 * @param {com.inq.flash.client.control.ApplicationController}  controller
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setApplicationController = function(controller) {
	haxe.Log.trace("setApplicationController: entered",{ fileName : "SkinControl.hx", lineNumber : 295, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "setApplicationController"});
	com.inq.flash.client.chatskins.SkinControl.applicationController = controller;
};

/**
 * setTranscriptWindowSettings
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function setTranscriptWindowSettings():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setTranscriptWindowSettings = function() {
	com.inq.flash.client.chatskins.SkinControl.transcriptAgentColor = "#0000CB";
	com.inq.flash.client.chatskins.SkinControl.transcriptCustomerColor = "#000000";
	com.inq.flash.client.chatskins.SkinControl.transcriptFontSize = "11pt";
	com.inq.flash.client.chatskins.SkinControl.transcriptIndent = "" + 80;
	com.inq.flash.client.chatskins.SkinControl.transcriptTabStops = "[" + com.inq.flash.client.chatskins.SkinControl.transcriptIndent + "]";

	com.inq.flash.client.chatskins.SkinControl.transcriptAgentColor = "#" + HxOverrides.substr("000000" + Std.string(com.inq.utils.Util.getConfig("lAgentColor",203).toString(16)),-6,null);
	com.inq.flash.client.chatskins.SkinControl.transcriptCustomerColor = "#" + HxOverrides.substr("000000" + Std.string(com.inq.utils.Util.getConfig("lCustomerColor",0).toString(16)),-6,null);
	com.inq.flash.client.chatskins.SkinControl.transcriptFontSize = "000000" + Std.string(com.inq.utils.Util.getConfig("pointSize","11")) + "pt";
	com.inq.flash.client.chatskins.SkinControl.transcriptFont = com.inq.utils.Util.getConfig("sFont","Veranda");
	com.inq.flash.client.chatskins.SkinControl.transcriptAgentSample = com.inq.utils.Util.getConfig("sSampleAgentText","Jessica:  ");
};


/**
 * AddCustomerTextToChatWindow
 *
 * $type TFun([{ name => Msg, t => TInst(String,[]), opt => false },{ name => position, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * public static function AddCustomerTextToChatWindow(Msg:String, position:Int):Int
 * @public
 * @static
 * @param {string}  Msg
 * @param {number}  position
 * @param {Array=} expressionList
 * @param {string=} restoreMode - will be "1" when page with chat is reloaded
 * @param {Date=}  messageTimestamp
 * @param {boolean=} isHistoric Indicates if conversation should be added to the historic transcript array
 * @return {number}
 */
com.inq.flash.client.chatskins.SkinControl.AddCustomerTextToChatWindow = function(Msg,position, expressionList, restoreMode, messageTimestamp, isHistoric) {
	return com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
		com.inq.flash.client.control.FlashVars.getCustomerName(),
		com.inq.flash.messagingframework.StringUtils.htmlEncode(Msg),
		com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER,
		position,
		expressionList,
		restoreMode,
		"",
		messageTimestamp,
		isHistoric
	);
};

/**
 * Add Automaton Form data to chat window as a transcript item
 * Used by ACIF
 * @param {String} Msg
 * @param {Number} position
 * @param {Array=} expressionList
 * @param {string=} restoreMode - will be "1" when page with chat is reloaded
 * @param {Date=}  messageTimestamp
 * @param {boolean=} isHistoric Indicates if conversation should be added to the historic transcript array
 * @return {number}
 */
com.inq.flash.client.chatskins.SkinControl.addAutomatonDataToChatWindow = function(Msg, position, expressionList, restoreMode, messageTimestamp, isHistoric) {
	return com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
		"",
		Msg,
		com.inq.flash.client.chatskins.ChatTextArea.AUTOMATON_DATA,
		position,
		expressionList,
		restoreMode,
		"",
		messageTimestamp,
		isHistoric
	);
};

/**
 * ReAddCustomerTextToChatWindow
 *
 * $type TFun([{ name => Msg, t => TInst(String,[]), opt => false },{ name => position, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * public static function ReAddCustomerTextToChatWindow(Msg:String, position:Int):Int
 * @public
 * @static
 * @param {string}  Msg
 * @param {number}  position
 * @return {number}
 */
com.inq.flash.client.chatskins.SkinControl.ReAddCustomerTextToChatWindow = function(Msg,position) {
	if(com.inq.flash.client.chatskins.SkinControl.hostIndx < com.inq.flash.client.chatskins.SkinControl.customerIndx) return -1;
	com.inq.flash.client.chatskins.SkinControl.hostIndx++;
	return com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(com.inq.flash.client.control.FlashVars.getCustomerName(),Msg,com.inq.flash.client.chatskins.ChatTextArea.CUSTOMER,position);
};


/**
 * isContinued
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isContinued()
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isContinued = function() {
	return !!com.inq.flash.client.control.FlashVars.isContinued();
};


/**
 * ClearTranscript
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function ClearTranscript():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.ClearTranscript = function() {
	Application.application.notificationController.hideNotification();
	try {
		if (null != com.inq.flash.client.chatskins.SkinControl.cw) {
			com.inq.flash.client.chatskins.SkinControl.cw.clearTranscript();
		}
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ClearTranscript error: " + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 353, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "ClearTranscript", customParams : ["error"]});
		} else throw(e);
	}
};

/**
 * Clears array transcript with current conversation
 */
com.inq.flash.client.chatskins.SkinControl.clearTranscriptArray = function() {
	try {
		if (com.inq.flash.client.chatskins.SkinControl.cw) {
			com.inq.flash.client.chatskins.SkinControl.cw.clearTranscriptArray();
		}
	} catch( e ) {
		haxe.Log.trace("clearTranscriptArray error: " + Std.string(e));
	}
};

/**
 * Clears openers array
 */
com.inq.flash.client.chatskins.SkinControl.clearOpenersArray = function () {
	if (com.inq.flash.client.chatskins.SkinControl.cw) {
		com.inq.flash.client.chatskins.SkinControl.cw.clearOpenersArray();
	}
};

com.inq.flash.client.chatskins.SkinControl.updateCustomerName = function(name) {
	if (com.inq.flash.client.chatskins.SkinControl.cw) {
		com.inq.flash.client.chatskins.SkinControl.cw.updateCustomerName(name);
	}
};

/**
 * Adds separator line between two conversations to the historic transcript array
 */
com.inq.flash.client.chatskins.SkinControl.addConversationSeparator = function() {
	com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow(
		"",
		"",
		com.inq.flash.client.chatskins.ChatTextArea.SEPARATOR,
		-1,
		null,
		"1",
		null,
		null,
		true
	);
};


/**
 * AddTranscriptItemToChatWindow
 *
 * $type TFun([{ name => Id, t => TInst(String,[]), opt => false },{ name => Msg, t => TInst(String,[]), opt => false },{ name => ChatType, t => TInst(Int,[]), opt => false },{ name => position, t => TInst(Int,[]), opt => false }],TInst(Int,[]))
 * public  static function AddTranscriptItemToChatWindow(Id:String, Msg:String, ChatType:Int, position:Int):Int
 * @public
 * @static
 * @param {string}  Id
 * @param {string}  Msg
 * @param {number}  ChatType
 * @param {number}  position
 * @param {Array=} expressionList
 * @param {string=} restoreMode - will be "1" when page with chat is reloaded
 * @param {String=} cssClass - If specified, append it to the "class" attribute of the systemMsg.  RTDEV-17612
 * @param {Date=}  messageTimestamp
 * @param {boolean=} isHistoric Indicates if conversation should be added to the historic transcript array
 * @return {number}
 */
com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow = function(Id,Msg,ChatType,position, expressionList, restoreMode,cssClass, messageTimestamp, isHistoric) {
	/** @type {Number} */
	var val = -1;
	haxe.Log.trace("SkinControl.AddTranscriptItemToChatWindow: entered",{ fileName : "SkinControl.hx", lineNumber : 360, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "AddTranscriptItemToChatWindow"});
	try {
		if (isHistoric) {
			val = com.inq.flash.client.chatskins.SkinControl.getChatWindow().addHistoricTranscript(Id, Msg, ChatType, position, cssClass, expressionList, messageTimestamp);
		} else {
			val = com.inq.flash.client.chatskins.SkinControl.getChatWindow().addTranscript(Id, Msg, ChatType, position, expressionList, restoreMode, cssClass, messageTimestamp);
		}
		com.inq.flash.client.chatskins.FormMgr.updateFormTimeExecutor(com.inq.flash.client.chatskins.SkinControl.cw);
	} catch( e ) {
		haxe.Log.trace("SkinControl.AddTranscriptItemToChatWindow: ERROR:" + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 365, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "AddTranscriptItemToChatWindow", customParams : ["error"]});
	}
	return val;
};


/**
 * modifyDTFields
 * modify DT fields in cache
 * 1. disable DT fields in cache (All inputs are disabled, All anchors are disabled, All click events are disabled)
 *
 *
 * OK This has changed.  We will send a message to the CR requesting the state change.
 * The CR will echo back the request.
 * When the CI gets the request, it will modify the elements.
 *
 * This way, when we replay the messages on subsequent pages, the elements will be disabled.
 *
 * $type TFun([{ name => dtId, t => TInst(String,[]), opt => false },{ name => selectedLinkName, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function modifyDTFields(dtId: String, selectedLinkName: String):Void
 * @public
 * @static
 * @param {string}  dtId -  id of dt span
 * @param {string}  selectedLinkName
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.modifyDTFields = function(dtId,selectedLinkName) {
	/** @type {HTMLElement} */
	var div = window.document.getElementById(dtId);
	/** @type {HTMLCollection} */
	var elements = div.getElementsByTagName("INPUT");
	/** @type {HTMLElement} */
	var el;
	if (elements.length > 0) {
		for (var i = 0, len = elements.length; i < len; i++) {
			el = elements[i];
			/* Get last element by this name */
			com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendInputState(el.name, "disabled", "true", true);
			/**
			 * We need to get the list again because we changed the state above "sendInputState"
			 * The element instances may have changed (IE problem)
			 */
			elements = div.getElementsByTagName("INPUT");
		}
	}
	/** @type {HTMLCollection} */
	var elements1 = div.getElementsByTagName("A");
	if (elements1.length > 0) {
		for (var j = 0, len1 = elements1.length; j < len1; j++) {
			el = elements1[j];
			/* Get last element by this name */
			/*
		 * If this is a selected link then we want it to be bolded
		 * So we set "disabled" attribute to bold
		 * otherwise to "true"
		 * The message handler "ChatAutomatonRequestElementSettingHandler.hx" will see
		 *   the "disabled" attribute name for the anchor and will apply the correct style for the link.
		 */
			com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendInputState(el.name,"disabled",selectedLinkName != el.name?"true":"bold",true);
		/**
		 * We need to get the list again because we changed the state above "sendInputState"
		 * The element instances may have changed (IE problem)
		 */
		elements1 = div.getElementsByTagName("A");
		}
	}
};


/**
 * modifyDTString
 * modify DT string
 * 1. disable DT fields in cache (All inputs are disabled, All anchors are disabled, All click events are disabled)
 * 2. add bold to selected link
 * 3. add checked for selected check boxes
 *
 * $type TFun([{ name => msg, t => TInst(String,[]), opt => false },{ name => selectedLinkName, t => TInst(String,[]), opt => false },{ name => selectedCheckboxNames, t => TDynamic(null), opt => false }],TInst(String,[]))
 * public static function modifyDTString(msg: String, selectedLinkName: String, selectedCheckboxNames: Dynamic):String
 * @public
 * @static
 * @param {string}  msg -  dt message's text
 * @param {string}  selectedLinkName -  selected link's name
 * @param {null}  selectedCheckboxNames -  names of selected check boxes
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.modifyDTString = function(msg,selectedLinkName,selectedCheckboxNames) {
	if(msg == null) return null;
	/*  add disabled to all input */
	msg = new EReg("<input","ig").split(msg).join("<input disabled ");

	/*  remove href='...' from <a> */
	msg = new EReg("(<a[^>]*)(href[\\s]*=[\\s]*['\"][^'\"]*['\"])([^>]*>)","ig").replace(msg,"$1 $3");

	/*  disable onclick: replace onclick="return window.Inq.DT.sendDTEvent..." to onclick="return false; window.Inq.DT.sendDTEvent... " */
	/*  so function sendDTEvent will not call ... */
	/* msg = ~/return /ig.split(msg).join("return false; "); */

	msg = new EReg("(<[^>]*)(onclick[\\s]*=[\\s]*['\"][^'\"]*return)([^>]*>)","ig").replace(msg,"$1 $2 false; $3");

	/*  The color of all disabled links should be changed to gray: replace <a to <a style='color:gray;' */
	msg = new EReg("<a","ig").replace(msg,"<a style='color:gray;' ");

	/** @type {EReg} */
	var rg;
	/** @type {string} */
	var out;
	if(selectedLinkName != null && selectedLinkName.length > 0) {
		/*  make bold */
		/*  replace name = "..." to name="..."  style='font-weight:bold;' */
		rg = new EReg("name[\\s]*=[\\s]*['\\\"]" + selectedLinkName + "['\\\"]","ig");
		out = "name ='" + selectedLinkName + "' style='font-weight: bold; color:#323232;' ";
		msg = rg.split(msg).join(out);
		/*  rebuild selected link */
		/** @type {EReg} */
		var rgLink = new EReg("<a([^>]*)(name[\\s]*=[\\s]*['\\\"]" + selectedLinkName + "['\\\"])([^>]*)>","ig");
		/** @type {string} */
		var outLink = "<a style= 'font-weight: bold; color:#323232;' onclick = 'return false;' $1>";
		msg = rgLink.replace(msg,outLink);
	}

	if (selectedCheckboxNames != null) {
		/*  set checked for selected check boxes */
		for (var i = 0; i < selectedCheckboxNames.length; i++) {
			/** @type {string} */
			var name = selectedCheckboxNames[i];
			/*  replace name='...' to name='...' checked */
			rg = new EReg("name[\\s]*=[\\s]*['\"]" + name + "['\"]","ig");
			out = "name ='" + name + "' checked ";
			msg = rg.split(msg).join(out);
		}
	}
	return msg;
};


/**
 * AddOpenerToChatWindow
 *
 * @public
 * @static
 * @param {string}  Id
 * @param {string}  Msg
 * @param {number}  ChatType
 * @param {number}  position
 * @param {Array} expressionList
 * @param {Date=} messageTimestamp
 * @return {number} position
 */
com.inq.flash.client.chatskins.SkinControl.AddOpenerToChatWindow = function(Id, Msg, ChatType, position, expressionList, messageTimestamp) {
	haxe.Log.trace("SkinControl.AddOpenerToChatWindow: entered",{ fileName : "SkinControl.hx", lineNumber : 472, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "AddOpenerToChatWindow"});
	return com.inq.flash.client.chatskins.SkinControl.cw.addOpenerScript(Id, Msg, ChatType, position, expressionList, messageTimestamp);
};

/**
 * MoveChatHistory
 *
 * $type TFun([{ name => chatWindow, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function MoveChatHistory(chatWindow:Dynamic):Void
 * @public
 * @static
 * @param {null}  chatWindow
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.MoveChatHistory = function(chatWindow) {
	return;
};


/**
 * isInApplication
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * static public function isInApplication(name:String):Bool
 * @public
 * @static
 * @param {string}  name
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isInApplication = function(name) {
	/** @type {Boolean} */
	var bExists = false;
	try {
		/** @type {Object} */
		var obj = Application.application.getMxmlItem(name);
		if(null != obj) bExists = true;
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			bExists = false;
		} else throw(e);
	}
	return bExists;
};

/**
 * doChatExit
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function doChatExit():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.doChatExit = function() {
	com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.flash.client.chatskins.SkinControl.applicationController.shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_DO_EXIT);
	/** @type {Boolean} */
	var tY = com.inq.flash.client.control.FlashPeer.isThankYouEnabled();
	if(tY) {
		com.inq.flash.client.chatskins.SkinControl.doThankYou();
		if(com.inq.flash.client.chatskins.SkinControl.isClick2call() && !com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
			/** @type {String} */
			var thankyouNoSubmit = com.inq.utils.Util.getConfig("thankyouNoSubmit",null);
			if(null != thankyouNoSubmit) {
				/** @type {com.inq.ui.Button} */
				var btnThankYou = Application.application.getButton("btnThankYou");
				btnThankYou.setLabel(thankyouNoSubmit);
			}
		}
	}
};

/**
 * send close event to automation view (XForms) only when automation is visible
 * @param {Event} event
 * @return {Boolean}
 */

com.inq.flash.client.chatskins.SkinControl.sendCloseEventToAutomations = function(event) {
	/** @type {boolean} */
	var sendingEventFlag = false;
	/** @type {Array.<com.inq.ui.XFrame>} */
	var xframes = Application.application.getXFrameItems();
	for(var i = 0; i < xframes.length; i++) {
		if (xframes[i].getVisible() && xframes[i].sendCustomEventToXForms(event, params)) {
			sendingEventFlag = true;
		}
	}
	return sendingEventFlag;
}

/**
 * Send custom event to automaton view (XForms)
 * @param event event name
 * @param {object} params - additional event parameters
 * @returns {boolean} true, if at least one of the com.inq.ui.XFrame objects handled the event
 */
com.inq.flash.client.chatskins.SkinControl.sendEventToAllAutomatons = function(event, params) {
	/** @type {boolean} */
	var sendingEventFlag = false;
	/** @type {Array.<com.inq.ui.XFrame>} */
	var xframes = Application.application.getXFrameItems();
	for(var i = 0; i < xframes.length; i++) {
		if (xframes[i].sendCustomEventToXForms(event, params)) {
			sendingEventFlag = true;
		}
	}
	return sendingEventFlag;
};

/**
 * doThankYou
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function doThankYou():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.doThankYou = function() {

	if (com.inq.flash.client.chatskins.SkinControl.isThankYouShown) {
		return;
	}

	/** @type {com.inq.ui.Button} */
	var btn = Application.application.getButton("btnCloseChatx") || Application.application.getButton("btnCloseChat");
	if(btn != null){
		//this code is to emulate MouseEvent on click (non-standard behavior)
		if(btn.styles["onClick"])
		{
			btn._div.onclick = null;
			btn._img.onclick = $bind(btn,com.inq.ui.Button.prototype.doClick);
		}
		btn.addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionCloseThankYouNotice);
	}
	Application.application.notificationController.disable();
	btn.addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionCloseThankYouNotice);
	com.inq.flash.client.chatskins.SkinControl.gotoThankyouScene();
};

/**
 * agentClosesChat
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function agentClosesChat():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.agentClosesChat = function() {
	/** @type {Boolean} */
	var tY = com.inq.flash.client.control.FlashPeer.isThankYouEnabled();
	/** @type {Boolean} */
	var closeChatOnAgentClose = com.inq.utils.Util.getConfig("closeChatOnAgentClose",false);

	com.inq.flash.client.chatskins.SkinControl.closeChatSession();
	com.inq.flash.client.chatskins.SkinControl.applicationController.disable();
	com.inq.flash.client.control.PersistenceManager.ClearValues();

	if (tY) {
		// If we're going to show the "Thank You" message, just say right where we are.
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.clearWindowPosition();
	}
	com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close();
	com.inq.flash.client.chatskins.CoBrowseMgr.agentEndsCob();
	/* RTDEV-2299  When the agent closes the chat, minimize functionality does not resume working on the same page unless cookies and cache are cleared*/
	/* Vodafone request, flag to turn close on agent close and no thank-you */
	if (closeChatOnAgentClose) {
		com.inq.flash.client.control.PersistenceManager.Close();
		com.inq.flash.client.control.MinimizeManager.Close();
		com.inq.flash.client.control.FlashPeer.onBeforeChatClosed();
		if(Application.application.getPreventChatClosed()) {
			Application.application.setPreventChatClosed(false);
            com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		} else {
			com.inq.flash.client.chatskins.SkinControl.closeChat();
			com.inq.flash.client.chatskins.SkinControl.closeParentWindow();
		}
		com.inq.aria.ModalWindow.removeCircularModalWindow();
	}
	else if (tY) {
        com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		com.inq.flash.client.chatskins.SkinControl.doThankYou();
	}
	else {
        com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		var agentExitLine = com.inq.flash.client.control.FlashVars.getValue("agentExitLine");
		if(agentExitLine.length > 0) {
			setTimeout(function() {
				com.inq.flash.client.chatskins.SkinControl.AddTranscriptItemToChatWindow("",
					com.inq.utils.StringUtil.htmlDecode(agentExitLine), // agentExitLine is html-encoded by jsp renderer upon script generation
					com.inq.flash.client.chatskins.ChatTextArea.SYSTEM,-1);
			}, 1000);
		}
		/**
		 * showing an overlay above user input elements like txt input and send button
		 * http://jira.touchcommerce.com/browse/RTDEV-8918
		 */
		var fadeInputsEls = Application.application.getMxmlItem("fadeUserInput");
		if(fadeInputsEls) {
			fadeInputsEls.setVisible(true);
		}
		var chatWindow = Application.application.getMxmlItem("chatWindow");
		if (chatWindow && chatWindow._div) {
			chatWindow._div.setAttribute("tabIndex", "-1");
			chatWindow._div.setAttribute("aria-hidden", "true");
			chatWindow._div.setAttribute("aria-label", "");
			chatWindow._div.removeAttribute("role");
		}
		com.inq.flash.client.chatskins.EmailMgr.hideEmailButton();
		com.inq.flash.client.chatskins.SkinControl.disableInput();
	}
	com.inq.flash.client.control.WebRTCMgr.close();
	com.inq.flash.client.chatskins.SkinControl.agentClosedChat = true;
};

/**
 * preparingClosingChat - is used to close session and stop the chat activity
 *
 * @static
 * @param {boolean=} isSalesforce
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.preparingClosingChat = function(isSalesforce) {
	com.inq.flash.client.chatskins.SkinControl.closeChatSession();
	com.inq.flash.client.chatskins.SkinControl.disableInput();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
	if (!isSalesforce) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close();
		com.inq.flash.client.chatskins.ScrollMonitor.Close();
		com.inq.flash.client.control.MinimizeManager.Close();
	}
	com.inq.flash.client.chatskins.SkinControl.endCobrowse();
	com.inq.flash.client.control.PersistenceManager.ClearValues();
	com.inq.flash.client.control.PersistenceManager.Close();
	com.inq.flash.client.control.MinimizeManager.Restore();
	com.inq.flash.client.control.UploadHandler.close();
};

/**
 * Closes the chat interface or stops the chat activity
 * in case when instance of chat was removed from the server side (on Chat Router).
 *
 * @public
 * @static
 * @param {boolean=} showNotification - the optional flag to show notification about loss of connection
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.connectionLostClosingChat = function(showNotification) {
	/* Event of lost connection can call this handler several times
	 * because it processes several asynchronous requests
	 * therefore need to prevent other attempts to close application and do this only once.
	 */
	if (!com.inq.flash.client.chatskins.SkinControl.getApplicationController().isConnected()) {
		return;
	}

	Application.application.disable(showNotification);

	if (Application.application.getPreventChatClosed()) {
        com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		com.inq.flash.client.chatskins.SkinControl.applicationController.shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CONNECTION_LOST);
		Application.application.setPreventChatClosed(false);
	} else {
		com.inq.flash.client.chatskins.SkinControl.preparingClosingChat();
		com.inq.flash.client.control.FlashPeer.setDisconnectFlag();

		if (!Application.application.notificationController.notificationIsActive()) {
			if (com.inq.flash.client.control.FlashPeer.isThankYouEnabled()) {
				com.inq.flash.client.chatskins.ChatTextFocusMonitor.clearWindowPosition(); // If we're going to show the "Thank You" message, just say right where we are. RTDEV-7232
				com.inq.flash.client.chatskins.SkinControl.doThankYou();
			} else {
				// StopTimer stops startPostChatTimer
				com.inq.flash.client.chatskins.SkinControl.StopTimer();
				com.inq.aria.ModalWindow.removeCircularModalWindow();
				com.inq.stage.ViewportMgr.close();
				com.inq.flash.client.chatskins.SkinControl.HideClientDecorations();
				com.inq.flash.client.control.FlashPeer.closeChat();
				com.inq.flash.client.chatskins.SkinControl.restoreFocusToMainWindow();
				com.inq.flash.client.chatskins.SkinControl.closeParentWindow();
			}
		}
	}
};

/**
 * This function closes chat session before start of SalesForce chat in our interface.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.closeThroughSalesforceChat = function () {

	var applicationController = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	com.inq.flash.client.chatskins.SkinControl.preparingClosingChat(true);

	if (applicationController.isConnected()) {
		com.inq.flash.client.chatskins.SkinControl.sendExitMsg(null, "closeThroughSalesforceChat");
		applicationController.disable();
	}

	com.inq.flash.client.control.WebRTCMgr.close();
	com.inq.aria.ModalWindow.removeCircularModalWindow();
	com.inq.flash.client.chatskins.OpenerScript.resetOpenersStopped();
	com.inq.flash.client.chatskins.SkinControl.bInitialized = false;
	com.inq.flash.client.chatskins.SkinControl.keyCount = 0;


	if (com.inq.utils.Capabilities.isSafari()) {
		var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
		if (txtInput) {
			txtInput._input.blur();
		}
	}
};

/**
 * cleanUpChatAndThankyou
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function cleanUpChatAndThankyou():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.cleanUpChatAndThankyou = function() {
	com.inq.flash.client.chatskins.SkinControl.closeChatSession();
	com.inq.flash.client.chatskins.SkinControl.sendExitMsg(null, "cleanUpChatAndThankyou");
	/* 	applicationController.disable(); */
	com.inq.flash.client.control.PersistenceManager.ClearValues();
	com.inq.flash.client.control.PersistenceManager.Close();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.flash.client.chatskins.SkinControl.ClearTranscript();
	com.inq.flash.client.chatskins.SkinControl.doThankYou();
};

/**
 * getThankYou
 *
 * $type TFun([],TInst(com.inq.ui.Canvas,[]))
 * public static function getThankYou ():Canvas
 * @public
 * @static
 * @return {com.inq.ui.Canvas}
 */
com.inq.flash.client.chatskins.SkinControl.getThankYou = function() {
	/** @type {com.inq.ui.Canvas} */
	var cTY = null;
	if(com.inq.flash.client.chatskins.SkinControl.wasSaleAction()) cTY = Application.application.getCanvas("thankYouSale");

	if(cTY == null) cTY = Application.application.getCanvas("thankYou");
	return cTY;
};

/**
 * getThankYouButton
 *
 * $type TFun([],TInst(com.inq.ui.Button,[]))
 * public static function getThankYouButton():Button
 * @public
 * @static
 * @return {com.inq.ui.Button}
 */
com.inq.flash.client.chatskins.SkinControl.getThankYouButton = function() {
	/** @type {com.inq.ui.Button} */
	var out = null;
	if(com.inq.flash.client.chatskins.SkinControl.wasSaleAction()) out = Application.application.getButton("btnThankYouSale");

	if(out == null) out = Application.application.getButton("btnThankYou");
	return out;
};


/**
 * fireMxmlHandler - execute handler in the MXML if it exists
 *
 * First we check to see if the handler is in the MXML in skinConfig JSON
 * If so we call it
 *
 * $type TFun([{ name => HandlerName, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function fireMxmlHandler(HandlerName:String):Void
 * @public
 * @static
 * @param {string}  HandlerName
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler = function(HandlerName) {
	try {
		/** @type {Function} */
		var func = com.inq.utils.Util.getConfig(HandlerName,null);
		if(func != null) func();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
};


/**
 * gotoThankyouScene
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function gotoThankyouScene():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.gotoThankyouScene = function() {
	/** @type {com.inq.ui.Canvas} */
	var cTY = com.inq.flash.client.chatskins.SkinControl.getThankYou();/* untyped Application.application.thankYou ;*/
	/** @type {com.inq.ui.Button} */
	var btnThankYou = com.inq.flash.client.chatskins.SkinControl.getThankYouButton();

	if (!!cTY && !!btnThankYou) {

		var tkyMsg = (!!btnThankYou.label) ? btnThankYou.label : com.inq.flash.client.chatskins.SkinControl.DEFAULT_TY_IMAGE_LABEL;
		var webCallS = com.inq.flash.client.control.WebRTCMgr.webCallStatus;

		com.inq.flash.client.chatskins.BalloonNotifier.Clear();
		com.inq.flash.client.chatskins.SkinControl.isThankYouShown = true;
		com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler("onThankYouVisible");

		if (webCallS === "started" || webCallS === "restarted" || webCallS === "callerror") {
			tkyMsg = com.inq.utils.Util.getConfig("webCallFailure","There is a problem connecting to Agent. Please try again.");
		} else if (!!com.inq.flash.client.chatskins.SkinControl.tYImageLabel) {
			tkyMsg = com.inq.flash.messagingframework.StringUtils.htmlEncode(com.inq.flash.client.chatskins.SkinControl.tYImageLabel);
		}

		if (com.inq.flash.client.chatskins.SkinControl.wasSaleAction()) {
			var thankYouSaleText = com.inq.utils.Util.getConfig("thankYouSaleText",null);
			if (!!thankYouSaleText && !!btnThankYou) {
				tkyMsg = thankYouSaleText;
			}
		}

		btnThankYou.setLabel(tkyMsg);
		btnThankYou.setAttribute("title", tkyMsg);  // CATO - ScreenReader should read same message.

		try {
			if(com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
				/** @type {com.inq.ui.Canvas} */
				var chatCanvas = Application.application.getCanvas("callForm");
				chatCanvas.setVisible(false);
				chatCanvas = Application.application.getCanvas("callFormPersistent");
				chatCanvas.setVisible(false);
			}
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				haxe.Log.trace("error" + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 662, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "gotoThankyouScene"});
			} else throw(e);
		}

		if(com.inq.utils.Capabilities.isSafari() || com.inq.utils.Capabilities.isAndroid() || com.inq.utils.Capabilities.isChromeiOS()) {
			com.inq.flash.client.control.FlashPeer.closeChatMonitor(false);
		}

		cTY.removeAttribute('aria-hidden');
		cTY.setVisible(true);

		if (!com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
			com.inq.flash.client.chatskins.SkinControl.ClearTranscript();
		}

		btnThankYou.setImageFocus();
	}

	if (!com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
		com.inq.flash.client.chatskins.SkinControl.disableInput();
	}
};
/**
 * Disabling stylesheets of closed chats
 * getting stylesheets count if stylesheets are present - disable them
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.disableOutdatedStylesheets = function() {
	if(com.inq.flash.client.control.FlashPeer.noV3FrameChat()){
		for (var i = 0; i < Application.application.styleLinksList.length; i++) {
			Application.application.styleLinksList[i].parentNode.removeChild(Application.application.styleLinksList[i]);
		}
	} else {
		for (var i = 0; i < Application.application.styleLinksList.length; i++) {
			Application.application.styleLinksList[i].disabled = true;
		}
	}
};

/**
 * HideClientDecorations
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function HideClientDecorations():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.HideClientDecorations = function() {
	com.inq.ui.ClientBody.closeAll();
	Application.application.closeMxmlItems();
	Application.application.setVisible(false);
	com.inq.flash.client.chatskins.SkinControl.disableOutdatedStylesheets();
};


/**
 * closeChat
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function closeChat():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.closeChat = function() {
	try {
		/* Any java command that causes the flash to be destroyed MAY NOT
		 be called via External Interface
		 These should be performed via navigateToURL
		 */
		com.inq.flash.client.chatskins.SkinControl.removeModalWindow();
		if (com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded == true) {
			com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn.remove();
		}
		com.inq.stage.ViewportMgr.close();
		com.inq.flash.client.chatskins.SkinControl.HideClientDecorations();
		com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
		com.inq.flash.client.chatskins.SkinControl.StopTimer();
		/* 	SkinControl.runJavaScript("Inq.FlashPeer.closeChat(false)", true) ; */
		com.inq.flash.client.control.FlashPeer.closeChat(com.inq.flash.client.chatskins.SkinControl.applicationController.isConnected());
		com.inq.flash.client.control.UploadHandler.close();
		com.inq.flash.client.chatskins.SkinControl.restoreFocusToMainWindow();
		com.inq.flash.client.chatskins.SkinControl.hasLastConversationMessages = false;
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("ERROR " + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 687, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "closeChat"});
		} else throw(e);
	}
};

/**
 * closeThankyou
 *
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.closeThroughThankYouScene = function() {
	com.inq.flash.client.chatskins.SkinControl.doThankYou();
	if (com.inq.flash.client.chatskins.SkinControl.isClick2call() && !com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		/** @type {String} */
		var thankyouNoSubmit = com.inq.utils.Util.getConfig("thankyouNoSubmit",null);
		if(null != thankyouNoSubmit) {
			/** @type {com.inq.ui.Button} */
			var btnThankYou = Application.application.getButton("btnThankYou ");
			btnThankYou.setLabel(thankyouNoSubmit);
		}
	}

	/* close persistent window if user clicks close button before persistent window is load */
	com.inq.flash.client.control.FlashPeer.closePersistentWindowIfOpen();
};

/**
 * Return focus to the main window, or the opener if we're in persistent mode.
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.restoreFocusToMainWindow = function() {
	if (!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		window.top.focus();
	}
	else {
		var opener = com.inq.flash.client.chatskins.SkinControl.getOpener();
		if (opener) {
			opener.focus();
		}
	}
};


/**
 * HideChat is old name of closeChat
 *
 * @deprecated
 */
com.inq.flash.client.chatskins.SkinControl.HideChat = com.inq.flash.client.chatskins.SkinControl.closeChat;

/**
 * ShowChat
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function ShowChat():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.ShowChat = function() {
};


/**
 * Scrolls the transcript to the end, so that the most recent message shows.
 */
com.inq.flash.client.chatskins.SkinControl.scrollTranscriptToEnd = function () {
	if (com.inq.flash.client.chatskins.SkinControl.cw) {
		com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
	}
};

/**
 * Returns true if the chat window is scrolled to the bottom, or false in another cases
 *
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isTranscriptScrolledToBottom = function () {
	return com.inq.flash.client.chatskins.SkinControl.cw ?
		com.inq.flash.client.chatskins.SkinControl.cw.isScrolledToBottom() :
		false;
}

/**
 * requestLcKillPopup
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function requestLcKillPopup():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.requestLcKillPopup = function() {
};


/**
 * ask4Transcript
 * Accepts the request from persistent chat for the transcript,
 * it:
 * Requests the shutdown (and disconnect) of the popup message handler
 * Waits for the disconnection before sending the transcript back to the
 * waiting persistent chat.
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function ask4Transcript():Void
 * @public
 * @static
 * @see		ask4TranscriptService() ;
 * @return {void} - void
 */
com.inq.flash.client.chatskins.SkinControl.ask4Transcript = function() {
};


/**
 * showPersistentChatButtons
 *
 * $type TFun([{ name => bShow, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function showPersistentChatButtons(bShow:Bool):Void
 * @public
 * @static
 * @param {boolean}  bShow
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons = function(bShow) {
	haxe.Log.trace("SkinControl:showPersistentChatButtons(" + Std.string(bShow) + ");",{ fileName : "SkinControl.hx", lineNumber : 723, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "showPersistentChatButtons"});
	if (!com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		/** @type {com.inq.ui.Button} */
		var clickPersistent = Application.application.getButton("ClickPersistent");
		if(null != clickPersistent) clickPersistent.setVisible(bShow);
	}
};


/**
 * showChatIDText
 *
 * $type TFun([{ name => bShow, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function showChatIDText(bShow:Bool):Void
 * @public
 * @static
 * @param {boolean}  bShow
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.showChatIDText = function(bShow) {
	haxe.Log.trace("SkinControl:showChatIDText(" + Std.string(bShow) + ");",{ fileName : "SkinControl.hx", lineNumber : 736, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "showChatIDText"});
	/** @type {com.inq.ui.Text} */
	var chatIDText = Application.application.getMxmlItem("ChatIDText");
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("ChatIDText")) chatIDText.setVisible(bShow);
};


/**
 * killPopup
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function killPopup():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.killPopup = function() {
	haxe.Log.trace("SkinControl.killPopup: Entered",{ fileName : "SkinControl.hx", lineNumber : 746, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "killPopup"});
	if (com.inq.flash.client.chatskins.SkinControl.applicationController.isConnected()) {
		com.inq.flash.client.chatskins.SkinControl.applicationController.shutdownQuietly(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_KILLPOPUP);
	}
	com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(false);

	try {
		com.inq.flash.client.control.FlashPeer.closeChat();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			com.inq.flash.client.chatskins.XTrace.StackTrace(e);
		} else throw(e);
	}
};


/**
 * endChatQuietPopup
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function endChatQuietPopup():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.endChatQuietPopup = function() {
	haxe.Log.trace("SkinControl.endChatQuietPopup: Entered",{ fileName : "SkinControl.hx", lineNumber : 757, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "endChatQuietPopup"});
	com.inq.flash.client.chatskins.SkinControl.sendExitMsg(null, "endChatQuietPopup");
	com.inq.flash.client.chatskins.SkinControl.quietPopup();
};


/**
 * quietPopup
 * Close the connection, shutdown, and show the thank-you page
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function quietPopup():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.quietPopup = function() {
	haxe.Log.trace("SkinControl.killPopup: Entered",{ fileName : "SkinControl.hx", lineNumber : 767, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "quietPopup"});
	try {
		com.inq.flash.client.control.FlashPeer.closeChat();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			com.inq.flash.client.chatskins.XTrace.StackTrace(e);
		} else throw(e);
	}
};


/**
 * goToPersistentChat
 *
 * $type TFun([{ name => obj, t => TDynamic(null), opt => true }],TEnum(Void,[]))
 * public static function goToPersistentChat(?obj:Dynamic):Void
 * @public
 * @static
 * @param {com.inq.events.Event} event
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.goToPersistentChat = function(event) {
	/** @type {Boolean} */
	var success;
	/** @type {com.inq.ui.Button} */
	var clickPersistent = null;

	/* The global flag 'SkinControl.bPersistBtnPressed' is used */
	/* To prevent persistent chat window open twice on FF */
	if (!com.inq.flash.client.chatskins.SkinControl.getApplicationController().isSendMessageFail()
		&& !com.inq.flash.client.chatskins.SkinControl.chatSessionEnded
		&& com.inq.flash.client.chatskins.SkinControl.bPersistBtnPressed == false) {

		com.inq.flash.client.chatskins.SkinControl.bPersistBtnPressed = true;
		/**
		 * @see http://jira.touchcommerce.com/browse/RTDEV-9863
		 */
		clickPersistent = Application.application.getButton("ClickPersistent");
		if(null != clickPersistent) {
			clickPersistent._img.blur();
		}
		success = com.inq.flash.client.control.FlashPeer.popOutChat(true,com.inq.flash.client.chatskins.SkinControl.resizable);
		com.inq.flash.client.chatskins.SkinControl.removeModalWindow();
		com.inq.aria.ModalWindow.removeCircularModalWindow();
		com.inq.flash.client.chatskins.SkinControl.stopOpenerScript(true);
		com.inq.flash.client.chatskins.SkinControl.StopTimer();
		com.inq.flash.client.chatskins.SkinControl.bPersistBtnPressed = false;
	}
};


/**
 * PushToFrameset
 *
 * $type TFun([{ name => _sUrl, t => TInst(String,[]), opt => false },{ name => _sTarget, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function PushToFrameset(_sUrl:String, _sTarget:String):Void
 * @public
 * @static
 * @param {string}  _sUrl
 * @param {string}  _sTarget
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.PushToFrameset = function(_sUrl,_sTarget) {
	try {
		/** @type {String} */
		var myURL = window.parent.document.URL;
		/** @type {String} */
		var destURL = HxOverrides.substr(_sUrl,_sUrl.length - 1,null) != "/"?_sUrl:HxOverrides.substr(_sUrl,0,_sUrl.length - 1);
		myURL = HxOverrides.substr(myURL,myURL.length - 1,null) != "/"?myURL:HxOverrides.substr(myURL,0,myURL.length - 1);
		if(_sTarget.toLowerCase() == "_self" && myURL.toLowerCase() == destURL.toLowerCase()) {
			haxe.Log.trace("SkinControl.PushToFrameset: already at target URL",{ fileName : "SkinControl.hx", lineNumber : 801, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "PushToFrameset"});
			return;
		}

		/*
		 * if there are outsanding TYPE_CHAT_AUTOMATON_SETTING message, do not push immediately,
		 * wait until done or timeout expire.
		 */
		com.inq.flash.client.chatskins.SkinControl.executeAfter(function() {
			return com.inq.flash.client.control.messagehandlers.ChatAutomatonRequestElementSettingHandler.hasNoOutstandingMessages();
		},function() {
			com.inq.flash.client.control.FlashPeer.PushToFrameset(destURL,_sTarget);
		}, "SkinControl.PushToFrameset", null, null);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {

			com.inq.flash.client.chatskins.XTrace.StackTrace("SkinControl.PushToFrameset:" + Std.string(e),"error");
		} else throw(e);
	}
};


/**
 * enablePersistentChatButtonAndEstablishUrl
 *
 * $type TFun([{ name => _sUrl, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function enablePersistentChatButtonAndEstablishUrl(_sUrl:String):Void
 * @public
 * @static
 * @param {string}  _sUrl
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.enablePersistentChatButtonAndEstablishUrl = function(_sUrl) {
	haxe.Log.trace("SkinControl.enablePersistentChatButtonAndEstablishUrl entered",{ fileName : "SkinControl.hx", lineNumber : 833, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "enablePersistentChatButtonAndEstablishUrl"});
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) return;
	/** @type {com.inq.ui.Button} */
	var ClickPersistent = Application.application.getButton("ClickPersistent");
	if(ClickPersistent.getVisible()) return;
	com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(true);
	/** @type {com.inq.ui.TextArea} */
	var chatWindow = Application.application.getMxmlItem("chatWindow");
	/** @type {Number} */
	var chatBottom = Std.parseInt(chatWindow.getStyle("bottom"));
	/** @type {Number} */
	var persHeight = Std.parseInt(ClickPersistent.getStyle("height"));
	/** @type {Number} */
	var newChatBtm = chatBottom + persHeight;
	/** @type {Number} */
	var newPersBtm = chatBottom;
	chatWindow.setStyle("bottom","" + newChatBtm);
	ClickPersistent.setStyle("bottom","" + newPersBtm);
	ClickPersistent.setStyle("left",chatWindow.getStyle("left"));
	ClickPersistent.setStyle("right",chatWindow.getStyle("right"));
	com.inq.flash.client.chatskins.SkinControl.inqPersistentUrl = _sUrl;
	/**
	 * Accessibility wants persistent button get focus while it is not so desirable behavior
	 *    to normal users especially while one is typing a message.
	 * So, move focus to persistent button only a customer is not typing.
	 * @ref RTDEV-9863, RTDEV-10804
	 */
	try {
		var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
		var txt = ti._getInput();
		if (txt.trim().length == 0 || txt == com.inq.flash.client.chatskins.SkinControl.getIntroduction()) {
			ClickPersistent.setImageFocus();
		}
	} catch (err) { /* DOM Operation */ }
};


/**
 * isClick2call
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isClick2call():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isClick2call = function() {
	if(!com.inq.flash.client.chatskins.SkinControl.click2call) com.inq.flash.client.chatskins.SkinControl.click2call = com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCall");
	return com.inq.flash.client.chatskins.SkinControl.click2call;
};

/**
 * check if the chat is launched from a c2webrtc type
 * @returns {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isClick2WebCall = function () {
	return com.inq.flash.client.control.FlashVars.getValue("launchType") === "C2WEBRTC";
};
/**
 * getCallerNameString
 *
 * $type TFun([],TInst(String,[]))
 * public static function getCallerNameString():String
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getCallerNameString = function() {
	return com.inq.flash.client.chatskins.SkinControl.callerNameString.length == 0?com.inq.flash.client.control.FlashVars.getCustomerName():com.inq.flash.client.chatskins.SkinControl.callerNameString;
};


/**
 * actionBtnCall
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * private static function actionBtnCall(me:MouseEvent):Void
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnCall = function(me) {
	var skinControl = com.inq.flash.client.chatskins.SkinControl;
	try {
		com.inq.flash.client.chatskins.SkinControl.click2call = true;
		com.inq.flash.client.chatskins.SkinControl.callStreamData = com.inq.flash.client.chatskins.SkinControl.getCallStreamData() + com.inq.flash.client.chatskins.SkinControl.getCallFormData();

		/** @type {com.inq.ui.TextInput} */
		var txtInput = skinControl.getTextInputField();
		/** @type {String} */
		var text = txtInput._getInput();
		if(text != "") {
			com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
			com.inq.flash.client.chatskins.SkinControl.StopTimer();
		}

		/** @type {?String} */
		var thankyouNoAgentOnSubmit = com.inq.utils.Util.getConfig("thankyouNoAgentOnSubmit",null);
		/** @type {?String} */
		var thankyouAfterHoursOnSubmit = com.inq.utils.Util.getConfig("thankyouAfterHoursOnSubmit",null);
		if(thankyouNoAgentOnSubmit == null && thankyouAfterHoursOnSubmit != null) thankyouNoAgentOnSubmit = thankyouAfterHoursOnSubmit;
		if(thankyouAfterHoursOnSubmit == null && thankyouNoAgentOnSubmit != null) thankyouAfterHoursOnSubmit = thankyouNoAgentOnSubmit;
		com.inq.flash.client.chatskins.SkinControl.applicationController.callButtonClicked(text, com.inq.flash.client.chatskins.SkinControl.callStreamData, com.inq.flash.client.chatskins.SkinControl.getCallerNameString());
		/** @type {boolean} */
		var success = com.inq.flash.client.control.FlashPeer.popOutChat(true, false);

		if(success) {
			/** @type {com.inq.ui.Canvas} */
			var chatCanvas = Application.application.getCanvas("callForm");
			chatCanvas.setVisible(false);
		}
	} catch( unknown ) {

		haxe.Log.trace("Unknown exception : " + Std.string(unknown),{ fileName : "SkinControl.hx", lineNumber : 883, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "actionBtnCall"});
		return;
	}
};


/**
 * actionBtnSend
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * private static function actionBtnSend(me:MouseEvent):Void
 * @private
 * @static
 * @param {com.inq.events.MouseEvent=} me - the event object, can be absent for keyboard and custom events
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnSend = function(me) {
	if (me && me.originalEvent && me.originalEvent.stopPropagation) {
		me.originalEvent.stopPropagation();
	}
	/** @type {com.inq.ui.TextInput} */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();

	/*
	 *  Accessibility trick.
	 */
	if(com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isAccessibilityHelpOnBtnSend) {
		ti.setFocus(true);
		return;
	}

	if (com.inq.flash.client.chatskins.ChatTextFocusMonitor.isBlurHandlerPending()) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.cancelBlurHandler();
		ti.setFocus(true);
	}

	try {
		/** @type {String} */
		var txt = ti._getInput();
		if (txt.trim().length > 0 && com.inq.flash.client.chatskins.SkinControl.keyCount > 0) {
			com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
			com.inq.flash.client.chatskins.SkinControl.StopTimer();
			com.inq.flash.client.chatskins.SkinControl.applicationController.sendButtonClicked(txt);
			ti.clear();
			if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().isFirstMessageSent()) {
				ti.clearPlaceholder();
			}
		}
		com.inq.flash.client.chatskins.SkinControl.whenStoppedTyping();
		ti.setFocus(true);
	} catch( e ) {
	}
	return false;
};


/**
 *
 *  Accessibility help on mobile Safari - to solve conflicts requirement of initial focus and issues on Safari
 *
 *  CATO Accessibility wants focus on input field
 *  RTDEV-9003 (scroll monitor is confused since focus event is missing with focus on input field.)
 *
 *  To solve the issue, default focus is on the send button with the following logic;
 *  1. Send button title is set with introductory message (e.g. "Double tab to enable text edit mode") button
 *  2. On blur event, accessibility help is removed.
 *  3. On click event, accessibility help is removed and focus is set to chat input field.
 *
 * @public
 * @static
 * @type {com.inq.flash.client.chatskins.AccessibilityHelp}
 */
com.inq.flash.client.chatskins.SkinControl.accessibilityHelp = com.inq.flash.client.chatskins.AccessibilityHelp.createInstance();

/**
 * actionBtnPopOut
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function actionBtnPopOut(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnPopOut = function(me) {
	com.inq.flash.client.chatskins.SkinControl.removeModalWindow();
	return com.inq.flash.client.control.FlashPeer.popOutChat(true,com.inq.flash.client.chatskins.SkinControl.resizable);
};

/**
 * customerClosingChat
 * Clean up after the customer requests closing of the chat
 * This can safely be done before the chat exit has finished.
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function customerClosingChat():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.customerClosingChat = function () {
	/** @type {com.inq.flash.client.control.ApplicationController} */
	var applicationController = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	var functionName = "customerClosingChat";

	com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
	com.inq.flash.client.chatskins.SkinControl.ClearTranscript();
	com.inq.flash.client.chatskins.SkinControl.endCobrowse();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	if (com.inq.flash.client.chatskins.SkinControl.isThankYouShown) {
		//chat will be closed by com.inq.flash.client.chatskins.SkinControl.closeThroughThankYouScene
		return;
	}
	com.inq.flash.client.control.FlashPeer.onBeforeChatClosed();
	com.inq.flash.client.chatskins.SkinControl.closeChatSession();
	if (!Application.application.getPreventChatClosed()) {
		com.inq.flash.client.control.PersistenceManager.ClearValues();
		com.inq.flash.client.control.PersistenceManager.Close();
		com.inq.flash.client.control.MinimizeManager.Close();
		com.inq.flash.client.chatskins.ScrollMonitor.Close();
		com.inq.flash.client.control.WebRTCMgr.close();
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close();
		com.inq.flash.client.chatskins.SkinControl.hideClientInterface();
		com.inq.flash.client.chatskins.SkinControl.sendExitMsg(
			com.inq.flash.client.chatskins.SkinControl.customerClosedChat,
			functionName
		);

		/*
		 * @see RTDEV-15160
		 * Bug:
		 *      In iOS10, the close button does not bring down the soft keyboard (both safari and chrome)
		 * Fix:
		 *      Explicitly remove the focus from the input textarea. This is done after all the listeners have been unbound and
		 *      before the chat div is removed from its parent node. This forces the OS to bring down the soft keyboard.
		 */
		if (com.inq.utils.Capabilities.isSafariVersion10()||com.inq.utils.Capabilities.isSafariVersion11() || com.inq.utils.Capabilities.isSafariVersion12()) {
			var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
			if (txtInput) {
				txtInput._input.blur();
			}
		}

		applicationController.disable();
		applicationController.msgcntAtEntry = 0;

		com.inq.aria.ModalWindow.removeCircularModalWindow();
		com.inq.flash.client.chatskins.OpenerScript.resetOpenersStopped();
		com.inq.flash.client.chatskins.SkinControl.bInitialized = false;
		com.inq.flash.client.chatskins.SkinControl.keyCount = 0; // RTDEV-20027 - reset this count
	} else {
        com.inq.flash.client.chatskins.SkinControl.startPostChatTimer();
		if (applicationController.isConnected()) {
			com.inq.flash.client.chatskins.SkinControl.sendExitMsg(null, functionName);
			applicationController.disable();
		}
		Application.application.setPreventChatClosed(false);
	}
};


/**
 * Hide chat if it's not persistent or show thank-you image after the customer closed the chat
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.hideClientInterface = function() {
	var isPersistentFrame = com.inq.flash.client.control.FlashPeer.isPersistentWindow();

	if (isPersistentFrame) {
		return;
	}

	var thankYou = com.inq.flash.client.chatskins.SkinControl.isThankYou;
	var thankYouShown = com.inq.flash.client.chatskins.SkinControl.isThankYouShown;
	var thankYouCanvas = Application.application.getCanvas("thankYou");
	var interacted = com.inq.flash.client.control.Incrementality.interacted;

	if (thankYou && thankYouCanvas && interacted && !thankYouShown) {
		com.inq.flash.client.chatskins.SkinControl.closeThroughThankYouScene();
	} else {
		com.inq.flash.client.chatskins.SkinControl.HideClientDecorations();
	}
};


/**
 * Clean up after the customer closed the chat
 * This is to be done only after the return of the chat.exit
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.customerClosedChat = function() {

	if (!com.inq.flash.client.chatskins.SkinControl.isThankYouShown) {
		com.inq.flash.client.chatskins.SkinControl.closeChat();
		if (Application.application.close != null) {
			Application.application.close();
		}
		com.inq.flash.client.chatskins.SkinControl.closeParentWindow();
	}

	/*
	 surveyWindow is created and used by BizRule. but loses focus because it opens on onBeforeChatClose event.
	 When all code is executed this following code will move focus back to survey window.
	 */
	if (typeof surveyWindow != "undefined") {
		// To make sure JAWS (Screen Reader) recognize focus moved to new window.
		setTimeout(function () {
			try {
				surveyWindow.focus();
			} catch (er) { }
		}, 1000);
	}
};

/**
 * actionCloseChat - is used to close chat from client side.
 *
 * @param {boolean=} tY - determines the state of the "thank-you" panel to display in the chat
 */
com.inq.flash.client.chatskins.SkinControl.actionCloseChat = function (tY) {
	if (tY === undefined) {
		tY = com.inq.flash.client.control.FlashPeer.isThankYouEnabled();
	}
	com.inq.flash.client.chatskins.SkinControl.isThankYou = !!tY;
	com.inq.flash.client.chatskins.SkinControl.customerClosingChat();
};

/**
 * endCobrowse
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function endCobrowse()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.endCobrowse = function() {
	com.inq.flash.client.chatskins.CoBrowseMgr.endCob();
};


/**
 * actionCloseThankYouNotice
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function actionCloseThankYouNotice(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.actionCloseThankYouNotice = function(me) {
	com.inq.flash.client.control.FlashPeer.onBeforeChatClosed();
	if(Application.application.getPreventChatClosed()) {
		Application.application.setPreventChatClosed(false);
        com.inq.flash.client.chatskins.SkinControl.restartTimer();
	} else {
		com.inq.flash.client.chatskins.ScrollMonitor.Close();
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.Close();
		com.inq.flash.client.control.PersistenceManager.ClearValues();
		com.inq.flash.client.control.PersistenceManager.Close();
		com.inq.flash.client.control.MinimizeManager.Close();
		com.inq.flash.client.control.WebRTCMgr.close();

		com.inq.flash.client.chatskins.SkinControl.closeChat();
		com.inq.flash.client.chatskins.SkinControl.closeParentWindow();
	}
	return false;
};

com.inq.flash.client.chatskins.SkinControl.actionFocusVideo = function(me) {
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("video")) {
//   com.inq.flash.client.chatskins.SkinControl.isInApplication("video").setFocus()
		com.inq.ui.Container._getElementById("tcChat_video",parent.document).focus()
	} else {
	}
	return false
};

/**
 * actionBtnCloseChat
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function actionBtnCloseChat(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat = function(me) {
	com.inq.flash.client.control.MinimizeManager.actionRestore();
	if (com.inq.utils.Util.getConfig(com.inq.utils.Util.xformsCloseEventFlag)) {
		// Send "chat close" event to automaton view (XForms)
		// or close chat if no automaton is active.
		/** @type {boolean} */
		var sendingEventFlag = com.inq.flash.client.chatskins.SkinControl.sendCloseEventToAutomations("onChatClose");
		/*
		 * sendingEventFlag means that:
		 * if onChatClose event had been sent to the automaton
		 *  then chat should be closed from automaton through XFrameWorker. () method,
		 * otherwise chat is closed here.
		 */
		if (!sendingEventFlag) {
			com.inq.flash.client.chatskins.SkinControl.actionCloseChat();
		}
	} else {
		com.inq.flash.client.chatskins.SkinControl.actionCloseChat();
	}
	return true;
};

/**
 * actionBtnClickToChat
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * private static function actionBtnClickToChat(me:MouseEvent):Void
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnClickToChat = function(me) {
};


/**
 * actionBtnCloseChatWindow - not used anymore
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * private static function actionBtnCloseChatWindow(me:MouseEvent):Void
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChatWindow = function(me) {
	com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(false);
	com.inq.flash.client.chatskins.SkinControl.applicationController.shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CUSTOMER_CLOSED);
	com.inq.flash.client.control.FlashPeer.closeChat();
};

/**
 *  actionRestoreAndExitChat
 *
 * public static function actionRestoreAndExitChat(me:MouseEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 *
 * @Description This function has been added for the ticket RTDEV-15908 and will be called from menu in the cobrowse banner.
 * The minimized chat needs to be restored before calling the actionBtnCloseChat, otherwise the 'Thank You' page will not be
 * displayed (because the 'Thank you' page's height and width depends on the size of the chat window)
 */
com.inq.flash.client.chatskins.SkinControl.actionRestoreAndExitChat = function(me) {
    com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(me);
    return true;
};

/**
 * actionClickOnTxtInput
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => false }],TEnum(Void,[]))
 * private static function actionClickOnTxtInput(me:MouseEvent):Void
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.actionClickOnTxtInput = function(me) {
	if(com.inq.flash.client.chatskins.SkinControl.bHaveFocus == false) {
		com.inq.flash.client.chatskins.SkinControl.bHaveFocus = true;
		haxe.Log.trace("Flash gained focus",{ fileName : "SkinControl.hx", lineNumber : 1067, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "actionClickOnTxtInput"});
	}
};


/**
 * actionAutoTabToPhoneField2
 * This function is to implement the autoTab functionality for phone field2
 * It auto-tab to phoneField2 upon completion of phoneField1.
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * private static function actionAutoTabToPhoneField2(ke:KeyboardEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean} - Bool
 */
com.inq.flash.client.chatskins.SkinControl.actionAutoTabToPhoneField2 = function (ke) {
	/** @type {com.inq.ui.TextInput} */
	var callerPhoneField1 = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField1");
	/** @type {com.inq.ui.TextInput} */
	var callerPhoneField2 = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField2");
	if (callerPhoneField1 != null && StringTools.trim(callerPhoneField1._getInput()).length == 3
		&& ((ke.keyCode >= 48 && ke.keyCode <= 57) || (ke.keyCode >= 96 && ke.keyCode <= 105) || ke.keyCode == 39)
		&& callerPhoneField1.getCursorPosition() == 3) {
		callerPhoneField2.setFocus();
	}
	return true;
};


/**
 * actionAutoTabToPhoneField3
 * This function is to implement the autoTab functionality for phone field3
 * It auto-tab to phoneField3 upon completion of phoneField2.
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * private static function actionAutoTabToPhoneField3(ke:KeyboardEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean} - Bool
 */
com.inq.flash.client.chatskins.SkinControl.actionAutoTabToPhoneField3 = function(ke) {
	/** @type {com.inq.ui.TextInput} */
	var callerPhoneField2 = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField2");
	/** @type {com.inq.ui.TextInput} */
	var callerPhoneField3 = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField3");
	if(callerPhoneField2 != null && StringTools.trim(callerPhoneField2._getInput()).length == 3
		&& ((ke.keyCode >= 48 && ke.keyCode <= 57) || (ke.keyCode >= 96 && ke.keyCode <= 105) || ke.keyCode == 39)
		&& callerPhoneField2.getCursorPosition() == 3) {
		callerPhoneField3.setFocus();
	}
	return true;
};

/**
 * setupButtons
 *
 * set buttons on div chat window toolbar.
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setupButtons = function() {
	try {
		/** @type {com.inq.ui.Stage} */
		var stg = Application.application.stage;
		if(stg != null) stg.addEventListener(com.inq.events.Event.RESIZE,com.inq.flash.client.chatskins.SkinControl.SkinResize);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}

	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnPopOut")) {
		Application.application.getButton("btnPopOut").addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.SkinControl.goToPersistentChat);
	}
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("ClickPersistent")) Application.application.getButton("ClickPersistent").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.goToPersistentChat);
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("ChatIDText")) Application.application.getTextInput("ChatIDText").setHtmlText("ID: <" + (Std.string(com.inq.flash.client.control.FlashVars.getValue("chatID")) + ">"));
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnSend")) Application.application.getButton("btnSend").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionBtnSend);
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCall")) Application.application.getButton("btnCall").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionBtnCall);

	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("chat_submit_phoneField1")) Application.application.chat_submit_phoneField1.addEventListener(com.inq.events.KeyboardEvent.KEY_UP,com.inq.flash.client.chatskins.SkinControl.actionAutoTabToPhoneField2);
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("chat_submit_phoneField2")) Application.application.chat_submit_phoneField2.addEventListener(com.inq.events.KeyboardEvent.KEY_UP,com.inq.flash.client.chatskins.SkinControl.actionAutoTabToPhoneField3);

	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCloseChat")) Application.application.getButton("btnCloseChat").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat);
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("txtInput")) com.inq.flash.client.chatskins.SkinControl.getTextInputField().addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionClickOnTxtInput);

	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnThankYou")) Application.application.getButton("btnThankYou").addEventListener(com.inq.events.MouseEvent.CLICK,com.inq.flash.client.chatskins.SkinControl.actionCloseThankYouNotice);
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnFocusVideo")) {
		Application.application.getButton("btnFocusVideo").addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.chatskins.SkinControl.actionFocusVideo)
	}
	if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnThankYouSale")) Application.application.getButton("btnThankYouSale").addEventListener(com.inq.events.MouseEvent.CLICK,actionCloseThankyouNotice);
};

/**
 * InitThankYouGraphic
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function InitThankYouGraphic():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.InitThankYouGraphic = function() {
	haxe.Log.trace("InitThankYouGraphic()",{ fileName : "SkinControl.hx", lineNumber : 1150, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitThankYouGraphic"});
	/** @type {com.inq.ui.Canvas} */
	var thankYou = com.inq.flash.client.chatskins.SkinControl.getThankYou();
	thankYou.setVisible(false);
	haxe.Log.trace("InitThankYouGraphic(): btnThankYou.visible = " + (thankYou.getVisible()?"true":"false"),{ fileName : "SkinControl.hx", lineNumber : 1153, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitThankYouGraphic"});

	thankYou.onRelease = function(evt) {
		com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(false);
		com.inq.flash.client.chatskins.SkinControl.applicationController.shutdown(com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_ONRELEASE);
		com.inq.flash.client.control.FlashPeer.closeChat();
	};
};

/**
 *
 * @param {string} text
 * @returns {Object}
 */
com.inq.flash.client.chatskins.SkinControl.checkForSpecialExpression = function(text) {
	text = com.inq.flash.client.chatskins.SkinControl.checkForGoToPersistentChatMsg(text);
	/** @type {object} */
	var result = {
		expressionList: [],
		text: text
	};
	return com.inq.flash.client.chatskins.SkinControl.checkForCustomerNameInputField(result);
};

/**
 * Extracts expressions from agent and system messages.
 * @param {Object} chatCommunicationMessage
 * @returns {Object} object which contains expression list and text message.
 */
com.inq.flash.client.chatskins.SkinControl.checkMessageForSpecialExpression = function(chatCommunicationMessage) {
	/** @type {string} */
	var chatTextKey = chatCommunicationMessage.getMessageType() == com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION_OUTCOME ? com.inq.flash.client.data.MessageFields.KEY_CLIENT_OUTCOME_DATA : com.inq.flash.client.data.MessageFields.KEY_CHAT_DATA;
	/** @type {string} */
	var chatText = chatCommunicationMessage.getProperty(chatTextKey);
	// Skip special expressions from customer messages.
	if (chatCommunicationMessage.getMessageType() != com.inq.flash.client.data.MessageFields.TYPE_CHAT_COMMUNICATION ||
		chatCommunicationMessage.getProperty(com.inq.flash.client.data.MessageFields.KEY_MSG_AGENT_ALIAS)) {
		return com.inq.flash.client.chatskins.SkinControl.checkForSpecialExpression(chatText);
	} else {
		return {
			expressionList: [],
			text: chatText
		};
	}

};

/**
 * checkForGoToPersistentChatMsg
 *
 * @public
 * @static
 * @param {string}  msg
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.checkForGoToPersistentChatMsg = function(msg) {
	haxe.Log.trace("SkinControl.as: checkForGoToPersistentChatMsg: entered",{ fileName : "SkinControl.hx", lineNumber : 1164, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});

	if(null == msg) {
		haxe.Log.trace("msg is null",{ fileName : "SkinControl.hx", lineNumber : 1168, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
		return "";
	}

	/*  if, and only if, the flash is non persistent, then
	 look for a message with the format
	 <a href="asfunction:goToPersistentChat,<<<UrlGoesHere>>>" target="PersistentChat"></a>
	 and get the URL
	 */
	/** @type {String} */
	var sMsgRevised = msg;

	haxe.Log.trace("SkinControl.as: checkForGoToPersistentChatMsg: msg = " + sMsgRevised.split("<").join("[").split(">").join("]"),{ fileName : "SkinControl.hx", lineNumber : 1179, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
	/** @type {Number} */
	var indx = msg.indexOf("asfunction:goToPersistentChat,");
	/** @type {String} */
	var sUrl = null;
	if(indx >= 0) {
		haxe.Log.trace("SkinControl.as: checkForGoToPersistentChatMsg: embeded anchor for asfunction:goToPersistentChat ",{ fileName : "SkinControl.hx", lineNumber : 1184, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
		/** @type {Number} */
		var ixAnchorEnd = -1;
		/** @type {Number} */
		var ixAnchorStart = -1;
		indx = msg.indexOf(",",indx) + 1;
		while(" " == HxOverrides.substr(msg,indx,1)) indx++;
		/** @type {Number} */
		var indxEnd = msg.indexOf("\"",indx);
		/* 	sUrl = msg.substring(indx, indxEnd) ; */
		sUrl = HxOverrides.substr(msg,indx,indxEnd - indx);
		/*  fix double ampersands in cID */
		sUrl = sUrl.split("&amp;").join("&");
		haxe.Log.trace("SkinControl.as: checkForGoToPersistentChatMsg: URL is '" + sUrl + "'",{ fileName : "SkinControl.hx", lineNumber : 1194, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});


		/*  look for the next tag terminator */
		ixAnchorEnd = msg.indexOf("</",indx);
		ixAnchorEnd = msg.indexOf(">",ixAnchorEnd);
		/*  look for the prior tag start */
		ixAnchorStart = msg.lastIndexOf("<",indx);

		/*  remove the anchor from the message */
		haxe.Log.trace("ixAnchorStart=" + ixAnchorStart,{ fileName : "SkinControl.hx", lineNumber : 1204, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
		haxe.Log.trace("ixAnchorEnd=" + ixAnchorEnd,{ fileName : "SkinControl.hx", lineNumber : 1205, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
		if(ixAnchorStart < ixAnchorEnd) {
			sMsgRevised = HxOverrides.substr(msg,0,ixAnchorStart) + HxOverrides.substr(msg,ixAnchorEnd + 1,null);
			haxe.Log.trace("OLD MESSAGE: " + msg.split("<").join("&lt;").split(">").join("&gt;"),{ fileName : "SkinControl.hx", lineNumber : 1209, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
			haxe.Log.trace("NEW MESSAGE: " + sMsgRevised.split("<").join("&lt;").split(">").join("&gt;"),{ fileName : "SkinControl.hx", lineNumber : 1210, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "checkForGoToPersistentChatMsg"});
		}
	}

	if(null != sUrl && !com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		com.inq.flash.client.chatskins.SkinControl.enablePersistentChatButtonAndEstablishUrl(sUrl);
	}
	return sMsgRevised;
};

com.inq.flash.client.chatskins.SkinControl.checkForCustomerNameInputField = function(expressionObject) {
	if (com.inq.ui.CustomerNameInputField.isContainsInsertionMarker(expressionObject.text)) {
		expressionObject.expressionList.push(com.inq.flash.client.data.MessageFields.CUSTOMER_NAME_INPUT_FIELD);
		expressionObject.text = com.inq.ui.CustomerNameInputField.removeInsertionMarker(expressionObject.text);
	}
	return expressionObject;
};
/**
 * reFormatMessage
 *
 * $type TFun([{ name => msg, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function reFormatMessage(msg:String):String
 * @public
 * @static
 * @param {string}  msg
 * @return {string}
 *
 * TODO: Remove deprecated and no longer used methods - RTDEV-14129
 */
com.inq.flash.client.chatskins.SkinControl.reFormatMessage = function(msg) {
	/** @type {String} */
	var sMsg = msg.toString();
	sMsg = sMsg.split("<br/></font><br/>").join("</font><br/>");
	sMsg = sMsg.split("<br /></font><br />").join("</font><br/>");
	sMsg = sMsg.split("</font><br/><br/>").join("</font><br/>");
	sMsg = sMsg.split("<font face=\"Verdana\" size=\"10\" color=\"#000000\">").join("<font face='Verdana' size='10' color='#000000'>");
	sMsg = sMsg.split("<font face=\"Verdana\" size=\"10\" color=\"#0000cd\">").join("<font face='Verdana' size='10' color='#0000cd'>");

	sMsg = sMsg.split("<chatBox>").join("");
	sMsg = sMsg.split("</chatBox>").join("");
	sMsg = sMsg.split("<chatBox />").join("");
	/* 	sMsg = sMsg.split("<").join("&lt;") ; */
	/* 	sMsg = sMsg.split(">").join("&gt;") ; */
	sMsg = com.inq.flash.client.chatskins.SkinControl.checkForGoToPersistentChatMsg(msg);
	return sMsg;
};


/**
 * setFocusOnInputField
 * in case of safari on ios forceButton boolean will determine where to set focus
 * @public
 * @static
 * @param {boolean} forceButton
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField = function (forceButton) {

	if (top.inqCustData && top.inqCustData.openerSetFocus) {
		/* openerSetFocus is used to point HTML DOM element need to be focused when chat is engaged by automation.
		 * Automation scxml need to define the object in portal
		 * e.g."Targeted Offers" tab of Portal > Administration > Engagement Experience > Automation
		 * @see RTDEV-13434
		 */
		top.inqCustData.openerSetFocus.focus();
		/* at least two events are calling this function and all need to used the object then cleaned */
		setTimeout(function () {
			top.inqCustData.openerSetFocus = null;
		}, 500);
	} else {
		/** @type {com.inq.ui.TextInput} */
		var textInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
		if (com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
			if (textInput && !com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
				textInput.setFocus();
			}
		} else if (!Application.setFocusToBtnCloseOnOpen) {
			if (forceButton && com.inq.utils.Capabilities.isMobile()) {
				com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.applyHelpOnBtnSend();
			} else if (textInput && !com.inq.flash.client.chatskins.EmailMgr.isEmailCanvasAndButtonVisible()) {
				textInput.setFocus();
			}
		}
	}
};

/**
 * setFocusOnCustomerNameInput - is used to set focus on the input element in the chat transcript.
 */
com.inq.flash.client.chatskins.SkinControl.setFocusOnCustomerNameInput = function () {
	var customerNameInputContainer = Application.application.getMxmlItem(com.inq.ui.CustomerNameInputField.prototype.CONTAINER_ID);

	if (customerNameInputContainer && customerNameInputContainer.getVisible() && customerNameInputContainer.customerNameInput) {
		window.setTimeout(function() {
			customerNameInputContainer.customerNameInput.setUpFocus();
		}, 100);
	}
};

/**
 * setFocusOnCloseButton
 * Set the focus on close button with a time delay
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setFocusOnCloseButton = function () {
    window.setTimeout(function () {
        var btnClose = Application.application.getButton("btnCloseChat");
        if (btnClose) {
            btnClose.setImageFocus();
        }
    }, 500);
};

/**
 * getTextInputField
 *
 * $type TFun([],TInst(com.inq.ui.TextInput,[]))
 * public static function getTextInputField():TextInput
 * @public
 * @static
 * @return {com.inq.ui.TextInput}
 */
com.inq.flash.client.chatskins.SkinControl.getTextInputField = function() {
	return Application.application.getTextInput("txtInput");
};

/**
 * uponEnterKey - performs the "send" operation
 * and not from the keyboard event handler
 * but from a timer event so not to "slow down"
 * the keyboard event handling
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function uponEnterKey():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.uponEnterKey = function() {
	com.inq.flash.client.chatskins.SkinControl.actionBtnSend(null);
};


/**
 * monitorCustomerTyping - performs the  operations that were previously in "onKeyDown"
 * and now not from the keyboard event handler
 * but from a timer event so not to "slow down"
 * the keyboard event handling
 * 1) trigger the  onEngaged event if appropriate
 * 2) increment keyCount
 * 3) set flag to show that we have focus
 * 4) send "customer starts typing" message if appropriate
 * 5) controll timer for "customer stops typing" message
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function monitorCustomerTyping():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.monitorCustomerTyping = function() {
	var appController = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	if (com.inq.flash.client.chatskins.SkinControl.keyCount == 0
		&& appController.msgcntAtEntry < 1) {
		window.setTimeout(com.inq.flash.client.control.Incrementality.onEngaged, 0);
	}
	com.inq.flash.client.chatskins.SkinControl.keyCount++;
	com.inq.flash.client.chatskins.SkinControl.bHaveFocus = true;


	if (appController.isChatInQueue() || !appController.isConnectionAccepted()) {
		// Not need to send type activity message until the agent is assigned on the chat.
		return;
	}

	if (!com.inq.flash.client.chatskins.SkinControl.isTypingInProgress()) {
		com.inq.flash.client.chatskins.SkinControl.setTypingActivity(true);
		window.setTimeout(com.inq.flash.client.chatskins.SkinControl.whenStartTyping, 0);
	}

	if (com.inq.flash.client.chatskins.SkinControl.timerForTyping != -1) {
		window.clearTimeout(com.inq.flash.client.chatskins.SkinControl.timerForTyping);
	}

	com.inq.flash.client.chatskins.SkinControl.timerForTyping = window.setTimeout(
		com.inq.flash.client.chatskins.SkinControl.whenStoppedTyping,
		com.inq.flash.client.chatskins.SkinControl.typingTimeout
	);
};

/**
 * Checks that typing activity is already detected.
 * @returns {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isTypingInProgress = function() {
	return com.inq.flash.client.chatskins.SkinControl.typeActivityMessageInProgress;
};

/**
 * Set the detecting state of the typing activity.
 * @param {boolean} flag
 */
com.inq.flash.client.chatskins.SkinControl.setTypingActivity = function(flag) {
	com.inq.flash.client.chatskins.SkinControl.typeActivityMessageInProgress = flag;
};

/**
 * onInput
 *
 * public static function onInput(e:InputEvent)
 * @public
 * @static
 * @param {InputEvent} e
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onInput = function(e) {
	// Since InputEvents don't tell us about what keys were pressed,
	// we figure out whether the user has pressed the "enter" key by
	// checking whether there's a newline anywhere in the input value.
	// We USED to be able to let newlines be added if the user held
	// down the "shift" or "ctrl" key. However, with InputEvent, we
	// can't know what the user pressed.
	if (/\n/.test(e.target.value)) {
		e.target.value = e.target.value.replace(/\n/g, "");
	}

	window.setTimeout(com.inq.flash.client.chatskins.SkinControl.monitorCustomerTyping,0);
	return true;
};
/**
 * on IE8 and below there is no onInput event because of that monitorCustomerTyping function will not be called when user paste a text on
 * to the chatinput
 * @param e {Event}
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onPaste = function(e) {
	window.setTimeout(com.inq.flash.client.chatskins.SkinControl.monitorCustomerTyping, 0);
	return true;
};

/**
 * onKeyDown - check for the "enter key" being depressed
 * if depressed, ask timer-event handler to
 * dispatch "actionBtnSend" via the new uponEnterKey method
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onKeyDown(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onKeyDown = function(ke) {
	if(com.inq.flash.client.chatskins.SkinControl.isSkinActive()) {
		if(ke.keyCode == com.inq.ui.Keyboard.ENTER) return false;
		return true;
	} else return true;
};


/**
 * onKeyPress
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onKeyPress(ke:KeyboardEvent)
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onKeyPress = function(ke) {
	try {
		var keyCode = (!ke.charCode) ? ke.keyCode : ke.charCode;
		if (keyCode === com.inq.ui.Keyboard.ENTER && !ke.altKey && !ke.ctrlKey && !ke.shiftKey) {
			com.inq.flash.client.chatskins.SkinControl.uponEnterKey();
			return false;
		}
		window.setTimeout(com.inq.flash.client.chatskins.SkinControl.monitorCustomerTyping, 0);
		return true;
	} catch (err) {
		haxe.Log.trace("ERROR: " + err,{ fileName : "SkinControl.js", lineNumber : 2010, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "onKeyPress"});
	}
};

/**
 * onKeyPressEmailInput
 *
 *  Email input text keypress event handler.
 *  RTDEV-7943 Enter key
 *  RTDEV-7945 ESC key
 *
 * @param ke
 * @returns {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onKeyPressEmailInput = function(ke) {
	if(ke.charCode == com.inq.ui.Keyboard.ENTER && !ke.altKey && !ke.ctrlKey && !ke.shiftKey) {
		com.inq.flash.client.chatskins.EmailMgr.actionBtnSendEmail();
		return false
	}

// CL RTDEV-7945
	if(ke.keyCode == com.inq.ui.Keyboard.ESCAPE) {
		com.inq.flash.client.chatskins.EmailMgr.unModalEmailCanvas();

		com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_NONE_STATE);
		com.inq.flash.client.chatskins.EmailMgr.setState(com.inq.flash.client.chatskins.EmailMgr.SHOW_BUTTON_STATE);

		var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
		txtInput.setFocus(false);
	}
	return true
};


/**
 * onKeyUp - we want to monitor the keyboard for "enter" key code
 * if the enter key is depressed, then we want to ignore it.
 * we then ask "monitorCustomerTyping" handler to perform other tasks after we return from this handler
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onKeyUp(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke - keyboard event data
 * @return {boolean} - false-if we are handling the event, true-if the browser is handling the event
 */
com.inq.flash.client.chatskins.SkinControl.onKeyUp = function(ke) {
	if(com.inq.flash.client.chatskins.SkinControl.isSkinActive()) {
		if(ke.keyCode == com.inq.ui.Keyboard.ENTER) {
			window.setTimeout(com.inq.flash.client.chatskins.SkinControl.uponEnterKey,0);
			return false;
		}
		window.setTimeout(com.inq.flash.client.chatskins.SkinControl.monitorCustomerTyping,0);
		return true;
	} else return true;
};


/**
 * isSkinActive
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function isSkinActive()
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isSkinActive = function() {
	/** @type {HTMLElement} */
	var inqFrameElement = window.frameElement;
	if(inqFrameElement != null) return inqFrameElement.style.display == "none"?false:true;
	return false;
};


/**
 * onKeyDownCall
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onKeyDownCall(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onKeyDownCall = function(ke) {
	return true;
};


/**
 * onKeyUpCall
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onKeyUpCall(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onKeyUpCall = function(ke) {
	var skinControl = com.inq.flash.client.chatskins.SkinControl;
	if(skinControl.keyCount == 0 && skinControl.applicationController.msgcntAtEntry < 1) {
		window.setTimeout(function () {
			com.inq.flash.client.control.Incrementality.onEngaged();
		}, 50);
	}
	skinControl.keyCount++;
	return true;
};


/**
 * onTextInputFocus
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onTextInputFocus(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onTextInputFocus = function(ke) {
	var skinControl = com.inq.flash.client.chatskins.SkinControl;
	if(skinControl.keyCount == 0 && skinControl.applicationController.msgcntAtEntry < 1) try {
		/** @type {com.inq.ui.TextInput} */
		var ti = skinControl.getTextInputField();
		if(null != $bind(ti,ti.select)) ti.select();
	} catch( e ) {
	}
	return true;
};


/**
 * whenStoppedTyping
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function whenStoppedTyping()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.whenStoppedTyping = function() {
	if(com.inq.flash.client.chatskins.SkinControl.timerForTyping != -1
		&& com.inq.flash.client.chatskins.SkinControl.isTypingInProgress()
	) {
		window.clearTimeout(com.inq.flash.client.chatskins.SkinControl.timerForTyping);
		com.inq.flash.client.chatskins.SkinControl.timerForTyping = -1;
		com.inq.flash.client.chatskins.SkinControl.applicationController.TypingActivity(false);
		com.inq.flash.client.chatskins.SkinControl.setTypingActivity(false);
	}
};


/**
 * whenStartTyping
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function whenStartTyping()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.whenStartTyping = function() {
	com.inq.flash.client.chatskins.SkinControl.applicationController.TypingActivity(true);
};


/**
 * onTextInputFocusLoss
 *
 * $type TFun([{ name => ke, t => TInst(com.inq.events.KeyboardEvent,[]), opt => false }],TEnum(Bool,[]))
 * public static function onTextInputFocusLoss(ke:KeyboardEvent):Bool
 * @public
 * @static
 * @param {com.inq.events.KeyboardEvent}  ke
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.onTextInputFocusLoss = function(ke) {
	com.inq.flash.client.chatskins.SkinControl.whenStoppedTyping();
	return true;
};


/**
 * setUpFocusAndSelection
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection = function ( isInitiate ) {
	var skinControl = com.inq.flash.client.chatskins.SkinControl;
	Application.application.setVisible(true);
	if (com.inq.utils.Util.getConfig("enableModal", false) == true && !com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
		com.inq.flash.client.chatskins.SkinControl.buildModalWindow();
	}

	/** @type {com.inq.ui.TextInput} */
	var txtInput = skinControl.getTextInputField();
    if (!com.inq.utils.Capabilities.isMobile() && isInitiate !== true) {
		if (!Application.setFocusToBtnCloseOnOpen) {
            // set focus to email input field if the email canvas is visible
            if (com.inq.flash.client.chatskins.EmailMgr.emailCanvas && com.inq.flash.client.chatskins.EmailMgr.emailCanvas.getVisible()) {
                var emailInputCapture = Application.application.getMxmlItem("emailInput");
                if (emailInputCapture) {
                    emailInputCapture.setFocus();
                }
            } else {
                txtInput.setFocus();
            }
        }
	}
	if (!Application.setFocusToBtnCloseOnOpen && !skinControl.isContinued() &&
		skinControl.applicationController.msgcntAtEntry === 0) {
		if (com.inq.utils.Capabilities.isMobile()) {
			skinControl.accessibilityHelp.applyHelpOnBtnSend();
		} else {
			txtInput.select();
		}
	}
};

/**
 * Used as wrapper for calling methods to build modal window for the chat.
 * The method from ModalWindow class calls asynchronously to avoid effect on drawing chat elements.
 */
com.inq.flash.client.chatskins.SkinControl.buildModalWindow = function () {
	setTimeout(com.inq.aria.ModalWindow.buildModalWindow, 1);
	if (window.buildNuanceModalWindow) {
		try {
			window.buildNuanceModalWindow(); //facade implementation  RTDEV-28379
		} catch (e) {
			haxe.Log.trace(
				"Failed to toggle buildNuanceModalWindow",
				{
					fileName : "SkinControl.js",
					lineNumber : 2795,
					className : "com.inq.flash.client.chatskins.SkinControl",
					methodName : "buildModalWindow"
				}
			);
		}
	}
};

/**
 * Used as wrapper for calling methods to hide/restore modal window effect for the chat.
 * The method from ModalWindow class calls asynchronously to avoid effect on drawing chat elements.
 *
 * @param {boolean} toShow
 */
com.inq.flash.client.chatskins.SkinControl.hideModalWindow = function (toShow) {
	setTimeout(
		function() {
			com.inq.aria.ModalWindow.hideModalWindow(toShow);
		},
		1
	);
	if (window.toggleNuanceModalWindow) {
		try {
			window.toggleNuanceModalWindow(toShow); //facade implementation  RTDEV-28379
		} catch (err) {
			haxe.Log.trace(
				"Failed to toggle toggleNuanceModalWindow",
				{
					fileName : "SkinControl.js",
					lineNumber : 2819,
					className : "com.inq.flash.client.chatskins.SkinControl",
					methodName : "hideModalWindow"
				}
			);
		}
	}
};

/**
 * Used as wrapper for calling methods to remove modal window effect for the chat.
 * The method from ModalWindow class calls asynchronously to avoid effect on drawing chat elements.
 */
com.inq.flash.client.chatskins.SkinControl.removeModalWindow = function () {
	setTimeout(com.inq.aria.ModalWindow.removeModalWindow, 1);
	if (window.removeNuanceModalWindow) {
		try {
			window.removeNuanceModalWindow(); //facade implementation  RTDEV-28379
		} catch (e) {
			haxe.Log.trace(
				"Failed to toggle removeNuanceModalWindow",
				{
					fileName : "SkinControl.js",
					lineNumber : 2041,
					className : "com.inq.flash.client.chatskins.SkinControl",
					methodName : "removeModalWindow"
				}
			);
		}
	}
};

/**
 * startKeyListener
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function startKeyListener():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.startKeyListener = function() {
	/** @type {com.inq.ui.TextInput} */
	var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if(txtInput == null) return;

	com.inq.flash.client.chatskins.SkinControl.typingTimeout = com.inq.utils.Util.getConfig("clientTypingTimout", com.inq.flash.client.chatskins.SkinControl.typingTimeout);

	if (com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
		txtInput.addEventListener(com.inq.events.KeyboardEvent.KEY_UP,com.inq.flash.client.chatskins.SkinControl.onKeyUpCall);
		txtInput.addEventListener(com.inq.events.KeyboardEvent.KEY_DOWN,com.inq.flash.client.chatskins.SkinControl.onKeyDeownCall);
	}
	else {
		txtInput.addEventListener("input", com.inq.flash.client.chatskins.SkinControl.onInput);
		/**
		 * @description on IE8 and below there is no onInput event because of that monitorCustomerTyping function will not be called when user paste a text on
		 * to the chatinput
		 * @see http://jira.touchcommerce.com/browse/RTDEV-10579
		 */
		if (com.inq.utils.Util.isIE && com.inq.utils.Util.getIEMajorVer(true) < 9) {
			txtInput.getInput().attachEvent("onpaste",com.inq.flash.client.chatskins.SkinControl.onPaste);
		}
		txtInput.addEventListener(com.inq.events.KeyboardEvent.KEY_PRESS,com.inq.flash.client.chatskins.SkinControl.onKeyPress);
		txtInput.addEventListener(com.inq.events.FocusEvent.FOCUS_OUT,com.inq.flash.client.chatskins.SkinControl.onTextInputFocusLoss);
		txtInput.addEventListener(com.inq.events.FocusEvent.FOCUS_IN,com.inq.flash.client.chatskins.SkinControl.onTextInputFocus);
	}
};

/**
 * startEmailKeyListener
 *
 * Set email transcript request input handler
 * 	RTDEV-7943
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.startEmailKeyListener = function() {
	var ti = Application.application.getTextInput("emailInput");

	if(ti && !com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
		ti.addEventListener(com.inq.events.KeyboardEvent.KEY_PRESS, com.inq.flash.client.chatskins.SkinControl.onKeyPressEmailInput)
	}
};

/**
 * setupLocalCommunications
 * Setup local communications between the Popup and Persistent SWFs
 *
 * $type TFun([],TEnum(Void,[]))
 * private static function setupLocalCommunications():Void
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setupLocalCommunications = function() {
};


/**
 * PushEmbeddedForm
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function PushEmbeddedForm():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.PushEmbeddedForm = function() {
};


/**
 * thankYou
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function thankYou():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.thankYou = function() {
};


/**
 * setAgentConfig
 *
 * $type TFun([{ name => agentID, t => TInst(String,[]), opt => false },{ name => eventData, t => TInst(com.inq.utils.Dictionary,[]), opt => false },{ name => coBrowseEnabled, t => TEnum(Bool,[]), opt => true },{ name => buID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function setAgentConfig(agentID:String, eventData:Dictionary, ?coBrowseEnabled:Bool = false, buID:String):Void
 * @public
 * @static
 * @param {string}  agentID string representation of agent ID
 * @param {com.inq.utils.Dictionary}  eventData includes agent last name, first name and agent attributes
 * @param {boolean}  coBrowseEnabled  flag shows is CoBrowse is enabled
 * @param {string}  buID chat business unit ID
 * @param {string}  agentGroupID agent group ID of chat owner
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.setAgentConfig = function(agentID,eventData,coBrowseEnabled,buID,agentGroupID) {
	if(coBrowseEnabled == null) coBrowseEnabled = false;
    if (!Application.application.isVirtualAgent() && com.inq.flash.client.chatskins.FontMgr.liveAgentSkin) {
		com.inq.ui.SkinLoader.LoadNewSkin(com.inq.flash.client.chatskins.FontMgr.liveAgentSkin);
	}
	com.inq.flash.client.control.FlashPeer.setAgentConfig(agentID,coBrowseEnabled,eventData,buID,agentGroupID);
	com.inq.flash.client.chatskins.SkinControl.sendEventToAllAutomatons("onAgentAssigned");
};


/**
 * onTimeout - After DEFAULT_INITIAL_TIMEOUT seconds without activity close the chat window
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onTimeout():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.onTimeout = function() {
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.stage.DragResize.WhenDone();

	if(com.inq.flash.client.chatskins.SkinControl.applicationController == null) return;
	try {
		com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
	} catch( e ) {
	}
};


/**
 * shutdownPopup
 * Requests the popup to close the connection, shutdown, and show the thank-you page
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function shutdownPopup():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.shutdownPopup = function() {
};


/**
 * ClassInits
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function ClassInits()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.ClassInits = function() {
	Application.application.notificationController.init();
	com.inq.flash.client.control.Incrementality.init();
	com.inq.flash.client.control.XFrameWorker.init();
	com.inq.flash.client.chatskins.FontMgr.init();
	com.inq.flash.client.chatskins.EmailMgr.init();

	// MAYBE: if skin has "onInitializationComplete" handler, which conditionally calls SndMgr.init, do not initialize SndMgr here.
	com.inq.flash.client.chatskins.SndMgr.lazyInit();

	com.inq.flash.client.chatskins.PrintMgr.init();
	com.inq.flash.client.chatskins.FocusMonitor.init();
	com.inq.flash.client.chatskins.ChatTextFocusMonitor.init();
	com.inq.flash.client.chatskins.FormMgr.init();
	com.inq.flash.client.chatskins.CoBrowseMgr.init();
	com.inq.flash.client.chatskins.VideoMgr.init();
	/*
	* RTDEV-27114: scroll monitors should be initiated before minimize manager because
	* MinimizeManager.init() internally invokes ScrollMonitor.bindAll()
	*/
	com.inq.flash.client.chatskins.ScrollMonitor.init();
	com.inq.flash.client.control.MinimizeManager.init();
	// announce chat is loading.
	com.inq.flash.client.control.XFrameWorker.ariaHelpOnLoadingButton();
	com.inq.flash.client.control.UploadHandler.init();
	com.inq.flash.client.control.WebRTCMgr();
	com.inq.ui.CommandParser.addListeners();
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciActionBtnCloseChat",com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat);
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSendAutomatonDataAsCustomerMessage", com.inq.flash.client.chatskins.SkinControl.sendAutomatonDataMessage);

	com.inq.flash.client.control.FlashPeer.setCiFunction("ciActionBtnCloseThankyou",com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat);
	/* Now that we have the action for the send button (after the addListeners), we can register it in FlashPeer in the IJSF, this is for Vodafone
	 * Please see RTDEV-5404
	 */
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciSendText",com.inq.flash.client.chatskins.SkinControl.actionBtnSend);
    /*
     *RTDEV-15908: Expose this method so that it can be called from the cobrowse banner bar in CI.
     */
    com.inq.flash.client.control.FlashPeer.setCiFunction("ciActionRestoreAndExitChat",com.inq.flash.client.chatskins.SkinControl.actionRestoreAndExitChat);

    // enable changing image according to agent type
	com.inq.flash.client.chatskins.SkinControl.InitializeAgentImage();
};

/**
 * Send automaton data message,
 * used in ACIF.
 * @param {string} text
 */
com.inq.flash.client.chatskins.SkinControl.sendAutomatonDataMessage = function(text) {
	com.inq.flash.client.chatskins.SkinControl.stopOpenerScript();
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
	com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendAutomatonDataMessage(text);
};

/**
 * InitializeAutomoton
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function InitializeAutomoton()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.InitializeAutomoton = function() {
	com.inq.flash.client.chatskins.SkinControl.startTimer(com.inq.flash.client.chatskins.SkinControl.TIMEOUT_AVOIDANCE_SEC, function() {
		com.inq.flash.client.control.PersistenceManager.SetValue(LAST_TOUCHED_TIME, new Date().getTime(), false);
	});
	/** @type {?String} */
	var iframeURL = com.inq.flash.client.control.PersistenceManager.GetValue(IFRAME_URL, null);
	if(iframeURL == null) {
		iframeURL = StringTools.urlDecode(com.inq.flash.client.control.FlashVars.getValue("iframeURL"));
		haxe.Log.trace("Flashvar iframeURL:" + iframeURL,{ fileName : "SkinControl.hx", lineNumber : 1576, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeAutomoton"});
	} else {
		iframeURL = StringTools.urlDecode(iframeURL);
		haxe.Log.trace("Persisted iframeURL:" + iframeURL,{ fileName : "SkinControl.hx", lineNumber : 1580, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeAutomoton"});
	}

	/** @type {com.inq.ui.IFrame} */
	var iframe = null;
	try {
		iframe = Application.application.getMxmlItem("autoAgentFrame");
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
		} else throw(e);
	}
	if(iframe != null) {
		iframe.setSrc(iframeURL);
		com.inq.flash.client.control.PersistenceManager.SetValue(IFRAME_URL, StringTools.urlEncode(iframeURL));
	} else haxe.Log.trace("uriFrame is null. Did you proerly ID the iframe component in the mxml?",{ fileName : "SkinControl.hx", lineNumber : 1590, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeAutomoton"});
};


/**
 * getIntroduction
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getIntroduction = function() {
	return com.inq.utils.Util.getConfig("sIntroduction",null);
};

/**
 * Shows introduction after preload messages
 *
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.showIntroductionAfterPreloadMessages = function () {
	/** @type {com.inq.ui.TextInput} */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if (!com.inq.flash.client.chatskins.SkinControl.cw.isCustomerMsgExist()) {
		ti.setIntroduction();
	}
};

/**
 * Start timer to close post-chat survey window after chat end.
 */
com.inq.flash.client.chatskins.SkinControl.startPostChatTimer = function () {
	var timeoutMilliSec = com.inq.flash.client.chatskins.SkinControl.getPostChatTimeout(); // @type {number}
	setTimeout(function () {
            com.inq.flash.client.chatskins.SkinControl.StopTimer();
            com.inq.flash.client.chatskins.SkinControl.closeChat();
		}, timeoutMilliSec
    );
};

/**
 * Start timer to close chat window if initiated and chat is not started with in the given seconds or
 * chat ended and no customer activity
 *
 * @param {number, optional} timeoutSec time in seconds before not started chat will be closed
 * @param {function, optional} timeoutAction another action for timer after timeout
 */
com.inq.flash.client.chatskins.SkinControl.startTimer = function (timeoutSec, timeoutAction) {
	if (com.inq.flash.client.control.FlashPeer.isAsyncUnauthUser()) {
		return;
	}

    if (!timeoutAction) {
        timeoutAction = function () {
            com.inq.flash.client.chatskins.SkinControl.timerTimeout.stop();
			// Once engaged this must not called.
            if (!com.inq.flash.client.control.FlashPeer.isOne2ManyChatEnabled()) {
                com.inq.flash.client.chatskins.SkinControl.onTimeout();
            }
            com.inq.flash.client.chatskins.SkinControl.timerTimeout = null;
        };
    }
	// Initialize timer object
	com.inq.flash.client.chatskins.SkinControl.initializeTimerTimeout(timeoutSec, timeoutAction);
};

/**
 * Restart timer for close not started chat. If parameters didn't set, then restart timer with parameters from previously run
 *
 * @param timeout time in seconds before not started chat will be closed
 * @param actionOnTimeout another action for timer after timeout
 */
com.inq.flash.client.chatskins.SkinControl.restartTimer = function(timeout, actionOnTimeout) {
	try {
		if (!timeout) {
			if (!com.inq.flash.client.chatskins.SkinControl.timeoutTime) {
				throw "timeout doesn't set and doesn't saved after 'startTimer'";
			}
			timeout = com.inq.flash.client.chatskins.SkinControl.timeoutTime;
		}
		if (!actionOnTimeout) {
			if (!com.inq.flash.client.chatskins.SkinControl.timeoutAction) {
				throw "actionOnTimeout doesn't set and doesn't saved after 'startTimer'";
			}
			actionOnTimeout = com.inq.flash.client.chatskins.SkinControl.timeoutAction;
		}
		// There is no need to start timer again if it has been already stopped. Otherwise we start timer to already started chat, and close already
		// started chat after timeout, what is not correct. This timer should close ONLY not started chats (it has not been assigned to agent).
		if (com.inq.flash.client.chatskins.SkinControl.timerTimeout != null) {
			com.inq.flash.client.chatskins.SkinControl.StopTimer();
			com.inq.flash.client.chatskins.SkinControl.startTimer(timeout, actionOnTimeout);
		}
	} catch (err) {
		haxe.Log.trace("Couldn't restart timer to close not started chat", { timeout:timeout, actionOnTimeout:actionOnTimeout, error:err });
	}
};

com.inq.flash.client.chatskins.SkinControl.loadChatTranscriptAndSetupTimeouts = function (msgcnt, appCont, ti) {
	if (com.inq.flash.client.chatskins.SkinControl.isChatEngaged()) {
		appCont.persistentFrameReconnect();
	} else if (com.inq.flash.client.chatskins.SkinControl.autoAgent == null
		|| com.inq.flash.client.chatskins.SkinControl.autoAgent.getVisible() == false
	) {
		if (com.inq.flash.client.chatskins.SkinControl.bChatIsVisible && !com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
			/** @type {Number} */
			var nowMs = new Date().getTime();
			/** @type {Number} */
			var chatWindowAppearedMs = com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_WINDOW_APPEARED, 0);
			/** @type {Number} */
			var initialTimeOutSec = com.inq.flash.client.chatskins.SkinControl.getInitialTimeout();

			// used at ChatMgr.prototype.onPageLanding to close chat window if
			// chat not engaged and timeout after first chat window appearance.
			// Please see: var initialTimeOut = chatInterfaceData.it;
			if (initialTimeOutSec !== com.inq.flash.client.control.FlashPeer.getInitialTimeout()) {
				com.inq.flash.client.control.PersistenceManager.SetValue("it", initialTimeOutSec, false);
			}

			var timeoutSec;
			if (chatWindowAppearedMs == 0) {
				com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_WINDOW_APPEARED, nowMs, false);
				timeoutSec = initialTimeOutSec;
			} else {
				var durationMs = nowMs - chatWindowAppearedMs;
				// timeoutSec should don't be negative because chat window should not showed by check in ChatMgr#onPageLanding
				timeoutSec = initialTimeOutSec - durationMs / com.inq.flash.client.chatskins.SkinControl.SEC;
			}
			com.inq.flash.client.chatskins.SkinControl.startTimer(timeoutSec);
		}
		ti.clear();
		ti.select();
	} else com.inq.flash.client.chatskins.SkinControl.InitializeAutomoton();
};

/**
 * This function is a timer that starts in {@link com.inq.flash.client.control.Incrementality.onEngaged}.
 *
 * The purpose of this timer is to close the chat window if user has not performed any actions
 * for an hour or more (in case when tab in mobile browser inactive), but has already started typing text in the
 * input field and the old timer for closing the chat due to inactivity is already turned off.
 *
 * The implementation checks every two minutes and after an hour, this function will close the chat.
 *
 * Also this timer will be stopped if the "chat.authorized" message has been received.
 *
 * @param {Date} startTimerDate - timer start date.
 */
com.inq.flash.client.chatskins.SkinControl.closeChatOneHourTimer = function(startTimerDate) {
	var currentDate = new Date();
	if (!com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().getHasAuthorized()) {
		if (startTimerDate.getTime() < (currentDate.getTime() - com.inq.flash.client.chatskins.SkinControl.HOUR)) {
			com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
		} else {
			setTimeout(function () {
				com.inq.flash.client.chatskins.SkinControl.closeChatOneHourTimer(startTimerDate);
			}, com.inq.flash.client.chatskins.SkinControl.MIN * 2);
		}
	}
};

/**
 * Warning: The following function must be called as the first instruction in the socket layer
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function InitializeGlue():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.InitializeGlue = function() {
	/** @type {com.inq.flash.client.control.ApplicationController} */
	var appCont = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	com.inq.flash.client.control.FlashPeer.setCiFunction("ciActionBtnCloseChat", com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat);
	if(com.inq.flash.client.chatskins.SkinControl.bInitialized) return;/*  REQ-1428*//*  REQ-1428*/
	com.inq.flash.client.chatskins.SkinControl.bInitialized = true;/*  REQ-1428*/
	com.inq.flash.client.chatskins.SkinControl.chatSessionEnded = false;
	com.inq.flash.client.chatskins.SkinControl.click2call = false;/*  RTDEV-2169*/
	com.inq.flash.client.chatskins.SkinControl.callStreamData = "";/*  RTDEV-2169*/
	com.inq.flash.client.chatskins.SkinControl.callerNameString = "";/*  RTDEV-2169*/
	com.inq.flash.client.chatskins.SkinControl.chatContainer = Application.application.getCanvas("Chat");
	/* Container "Chat" is a special container just under the title bar that contains
	 * the text area, the text input, and the send button and artwork
	 * If it does not exist, then:
	 *    consider  bChatIsVisible = true because this is the old artwork without the "Chat" canvas and will
	 *    not be CIV4 with XForms
	 * Else if it does exist, see if it is visible,
	 * On non visible "Chat" canvas, we do not want to:
	 *   1) Start the chat
	 *   2) Start openers
	 *   3) Start timeout
	 * When an XForm shows the "Chat" canvas then we start the chat, start opener script, and set the timeout
	 */
	if (com.inq.flash.client.chatskins.SkinControl.chatContainer == null) {
		com.inq.flash.client.chatskins.SkinControl.bChatIsVisible = true;
	} else {
		com.inq.flash.client.chatskins.SkinControl.bChatIsVisible = com.inq.flash.client.chatskins.SkinControl.chatContainer.getVisible() && com.inq.flash.client.chatskins.SkinControl.chatContainer.getEnabled();
	}
	com.inq.flash.client.chatskins.SkinControl.resizable = com.inq.utils.Util.getConfig("resizable",true);
	com.inq.flash.client.chatskins.SkinControl.autoAgent = com.inq.flash.client.chatskins.SkinControl.isInApplication("autoAgent")?Application.application.getCanvas("autoAgent"):null;
	com.inq.flash.client.chatskins.SkinControl.cw = new com.inq.flash.client.chatskins.ChatTextArea(Application.application.getMxmlItem("chatWindow"));

	com.inq.flash.client.chatskins.SkinControl.ClassInits();
	com.inq.flash.client.chatskins.SkinControl.stopScrollPropagation();

	com.inq.flash.client.chatskins.SkinControl.textInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();

	try {
		com.inq.flash.client.control.FlashVars.getFlashVars();
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("SkinControl.InitializeGlue: FlashVars threw: " + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 1629, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeGlue", customParams : ["error"]});
		} else throw(e);
	}
	haxe.Log.trace("SkinControl.InitializeGlue: FlashVars.flashVars.clickStream=" + com.inq.flash.client.control.FlashVars.get("clickStream"),{ fileName : "SkinControl.hx", lineNumber : 1631, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeGlue"});
	/** @type {com.inq.ui.TextInput} */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();

	if(com.inq.flash.client.control.FlashVars.getShutdownPopup()) {
		com.inq.flash.client.chatskins.SkinControl.shutdownPopup();
		return;
	}

	/** @type {number} */
	var msgcnt = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
	var isChatEngaged = com.inq.flash.client.chatskins.SkinControl.isChatEngaged();
	if (!com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		com.inq.flash.client.chatskins.SkinControl.showPersistentChatButtons(false);
		if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().isAsyncChat()) {
			com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = true;
			com.inq.flash.client.control.FlashPeer.getConversationTranscript(function() {
				if (!isChatEngaged) {
					com.inq.flash.client.chatskins.SkinControl.showOpenerScripts();
				}
				com.inq.flash.client.chatskins.SkinControl.loadChatTranscriptAndSetupTimeouts(msgcnt, appCont, ti);
				// We have 3 cases here:
				// 1) When we did not send any messages and do not need to connect to CR
				// 2) When we send message when we are still loading transcript
				// 3) And when we just navigate with active chat (need to establish connection with CR)
				// In loadChatTranscriptAndSetupTimeouts we call ApplicationController#persistentFrameReconnect but it will not connect due to
				// asyncTranscriptLoading is false at this moment and we will reconnect by initializeAutomatonOrTryConnect call then.
				com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = false;
				initializeAutomatonOrTryConnect();
			});
		} else {
			if (!isChatEngaged) {
				com.inq.flash.client.chatskins.SkinControl.showOpenerScripts();
			}
			com.inq.flash.client.chatskins.SkinControl.loadChatTranscriptAndSetupTimeouts(msgcnt, appCont, ti);
		}
	}/*  popup*/ else {
		com.inq.flash.client.chatskins.SkinControl.persistentChatInitialize();
		appCont.msgcntAtEntry = msgcnt;
		if (com.inq.flash.client.chatskins.SkinControl.getApplicationController().getChat().isAsyncChat()) {
			com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = true;
			com.inq.flash.client.control.FlashPeer.getConversationTranscript(function() {
				com.inq.flash.client.chatskins.SkinControl.asyncTranscriptLoading = false;
				if (isChatEngaged) {
					appCont.persistentFrameReconnect();
					return;
				} else {
					com.inq.flash.client.chatskins.SkinControl.showOpenerScripts();
					ti.clear();
					ti.select();
				}
				initializeAutomatonOrTryConnect();
			});
		} else {
			if (isChatEngaged) {
				appCont.persistentFrameReconnect();
			} else {
				com.inq.flash.client.chatskins.SkinControl.showOpenerScripts();
				ti.clear();
				ti.select();
			}
		}
		if (com.inq.flash.client.chatskins.SkinControl.isClick2call())
			appCont.processClickToCallQueueMessages();
		/** @type {Boolean} */
		var bPopupNotified = false;

		com.inq.flash.client.chatskins.SkinControl.ShowChat();

		com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection();
	}/*  persistent*//*  popup*/

	if (com.inq.flash.client.chatskins.SkinControl.isClick2WebCall()) {
		WebRTCMgr.init();
		WebRTCMgr.webCallStatus = "started";
		if (com.inq.flash.client.control.PersistenceManager.GetValue("wcall", 0) === 0) {
			WebRTCMgr.ringSnd && WebRTCMgr.ringSnd.audio.play();
			if (WebRTCMgr.getAndSDKInst()) {
				WebRTCMgr.getAndSDKInst().checkPermission();
			} else if (WebRTCMgr.isIOSSDK()) {
				WebRTCMgr.isIOSSDK().postMessage("checkPermission");
			} else {
				WebRTCMgr.accessConstrants(true, !WebRTCMgr.isAudioOnlyWebCall()).then(function (s) {
					s.getAudioTracks().forEach(function(track) {
						track.stop();
					});

					s.getVideoTracks().forEach(function(track) {
						track.stop();
					});
					appCont.processClickToWebCallQueueMessages();
				}).then(null, function () {
					WebRTCMgr.onError("perDenied");
				});
			}
		} else if (com.inq.flash.client.control.FlashPeer.isV3Continue()) {
			WebRTCMgr.webCallStatus = "restarted";
			if (WebRTCMgr.isIOSSDK() || WebRTCMgr.getAndSDKInst()) {
				WebRTCMgr.processCallStarted();
			}
		}
		com.inq.flash.client.chatskins.SkinControl.StopTimer();
	}
	else if (com.inq.flash.client.control.PersistenceManager.GetValue('wcall', 0) === 1 && Inq.CHM.isV3Continue()) {

		com.inq.flash.client.control.WebRTCMgr.webCallStatus = "restarted";
		if(WebRTCMgr.isIOSSDK() || WebRTCMgr.getAndSDKInst()) {
			WebRTCMgr.processCallStarted();
		} else {

			com.inq.flash.client.control.FlashPeer.loadKMSlibraries();
		}
	}
	/*  Initially, the emailLayer must be invisible ; */
	if (com.inq.flash.client.chatskins.SkinControl.isInApplication("emailLayer"))
		Application.application.getCanvas("emailLayer").setVisible(false);
	if (com.inq.flash.client.chatskins.SkinControl.isInApplication("thankYou"))
		Application.application.getCanvas("thankYou").setVisible(false);

	haxe.Log.trace("setup the buttons",{ fileName : "SkinControl.hx", lineNumber : 1701, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "InitializeGlue"});

	com.inq.flash.client.chatskins.SkinControl.setupButtons();
	if(com.inq.flash.client.chatskins.SkinControl.autoAgent == null || com.inq.flash.client.chatskins.SkinControl.autoAgent.getVisible() == false) {
		com.inq.flash.client.chatskins.SkinControl.startKeyListener();
		com.inq.flash.client.chatskins.SkinControl.startEmailKeyListener();

		var defaultChatAvailableNotification = "A chat window is available at the end of the page.";
		var chatAvailableNotificationDefinedInSkin = Application.application.skinConfig.chatAvailableAriaMessage;
		com.inq.aria.AriaMsg.addAriaMsg(chatAvailableNotificationDefinedInSkin || defaultChatAvailableNotification);

		/**
		 * If a user clicked the C2C button the launchType would equal "C2C"
		 * If a business rule timer opened the chat "proactively" after a certain amount of time the
		 * chat type would equal "POPUP"
		 * We can not change the focus if the user did not click the C2C button because it is an
		 * accessibility violation because the user could be using a screen-reader to listen to
		 * elements on the page, then suddenly the chat opens up and changes the focused element
		 * without asking the user.
		 * @type {boolean}
		 */
		var c2cClicked = this.applicationController.chat.getLaunchType() === "C2C";

		if (c2cClicked && !com.inq.flash.client.control.MinimizeManager.minimized && !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			var isPersistentFrame = com.inq.flash.client.control.FlashPeer.isPersistentWindow();
			if ((com.inq.utils.Util.isIE || com.inq.utils.Capabilities.isFF()) && !isPersistentFrame) {
				window.setTimeout(function () {
					com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
				}, 1000);
			} else if (!com.inq.utils.Capabilities.isPhone() && !(com.inq.utils.Capabilities.isSafari() && com.inq.utils.Capabilities.isMobile())) {
				com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField();
			} else {
				com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection();
			}
		}
	}

	if(com.inq.utils.Util.getConfig("bHideInput",false) && !com.inq.flash.client.chatskins.SkinControl.isContinued()) com.inq.flash.client.chatskins.SkinControl.hideInput(); else com.inq.flash.client.chatskins.SkinControl.showInput(true);
	com.inq.flash.client.chatskins.SkinControl.fireMxmlHandler("onInitializationComplete");
	com.inq.flash.client.chatskins.SkinControl.agentClosedChat = false;

	function initializeAutomatonOrTryConnect() {
		if (!appCont.initializeAutomatonMode()) {
			var connectionHandler = appCont.getMessagingFramework().getConnection();
			if (connectionHandler) {
				connectionHandler.establishConnection();
			}
		}
	}
};

/**
 * Returns true if chat already engaged
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isChatEngaged = function() {
	return com.inq.flash.client.chatskins.SkinControl.isContinued()
		&& (com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0) > 0
			|| com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_ENGAGED, false)
		);
};

/**
 * getIsPersistentChat
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function getIsPersistentChat():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat = function() {
	return com.inq.flash.client.control.FlashPeer.isPersistentWindow();
};

/**
 *  Return initialTimeout value from skin configuration mxml file or return given timeout or default value.
 *
 * @param timeout {number} timeout in seconds. This value will be returned if initialTimeout from skin won't be found.
 * @return {number} timeout in seconds
 */
com.inq.flash.client.chatskins.SkinControl.getInitialTimeout = function (timeout) {
	var defaultTimeout = timeout || com.inq.flash.client.control.FlashPeer.getInitialTimeout();
    return parseInt(com.inq.utils.Util.getConfig("initialTimeOut", defaultTimeout));
};

/**
 *  Return postChatTimeOut value from skin configuration mxml file or return default value (1h).
 *
 * @return {number} timeout in milliseconds
 */
com.inq.flash.client.chatskins.SkinControl.getPostChatTimeout = function () {
    var defaultTimeout = com.inq.flash.client.chatskins.SkinControl.DEFAULT_POST_CHAT_TIMEOUT_SEC;
    return parseInt(com.inq.utils.Util.getConfig("postChatTimeOut", defaultTimeout))  * 1000;
};

/**
 * startWarning
 *
 *  Start two warnings of;
 *   1. every two mins until chat starts or window closed
 *   2. 30secs before window is closed.
 *
 * @static
 * @return {number} initialTimeOut - chat window initial timeout in string
 */
com.inq.flash.client.chatskins.SkinControl.startWarning = function(initialTimeOut) {
	var initialTimeOutInt = parseInt(initialTimeOut);           // @type {number} convert initialTimeOut to int.
	var timeInMs = (new Date()).getTime();                      // @type {number} get current time in millisecond.
	var timeToClose = timeInMs + (initialTimeOutInt * 1000);    // @type {number} calculated time to close unstarted chat.
	var _aria = com.inq.aria.AriaMsg;

	// Warn customers that the chat will be closed in 30 sec.
	// Improve - make the period and message configurable.
	if ( initialTimeOutInt > 30){
		com.inq.flash.client.chatskins.SkinControl.warninglast30secId = setTimeout( function(){
			var now = (new Date()).getTime();
			if ( now < timeToClose ) {
				_aria.addAriaMsg("The chat window is closing in 30 seconds.");
			}
		}, ( parseInt(initialTimeOutInt) - 30) * 1000 );
	}

	// Warn customers every two minutes until chat is closed that the chat will be closed if chat is not started.
	// Improve - make the period and message configurable.
	if ( initialTimeOutInt > 120){
		com.inq.flash.client.chatskins.SkinControl.warningEvery2minId = setInterval(function(){
			var now = (new Date()).getTime();
			var timeLeftSec = parseInt((timeToClose - now) / 1000);
			if ( now < timeToClose ) {
				var minMsg = " " + ( (parseInt(timeLeftSec / 60) > 0) ? parseInt(timeLeftSec / 60) + " minutes" : "" );
				var secMsg = " " + ( (timeLeftSec % 60) > 0 ? (timeLeftSec % 60) + " seconds" : ""  );
				_aria.addAriaMsg("The chat window is closing in" + minMsg + secMsg);
			} else {
				clearInterval(com.inq.flash.client.chatskins.SkinControl.warningEvery2minId);
			}
		}, 120 * 1000 );
	}
}

/**
 * stopWarning
 *
 *  stop two warnings set by startWarning function incase
 *   1. chat is started.
 *   2. chat window is closed.
 *
 * @static
 */
com.inq.flash.client.chatskins.SkinControl.stopWarning = function() {
	if (com.inq.flash.client.chatskins.SkinControl.warningEvery2minId > 0) {
		clearInterval(com.inq.flash.client.chatskins.SkinControl.warningEvery2minId);
	}
	if (com.inq.flash.client.chatskins.SkinControl.warninglast30secId > 0) {
		clearTimeout(com.inq.flash.client.chatskins.SkinControl.warninglast30secId);
	}
	com.inq.aria.AriaMsg.clearAriaMsg();
};

/**
 * Create object of timerTimeout with selected or default timeout value.
 * This timer mainly used to close chat window if no customer activity before engage chat or
 * no customer activity after chat ended.
 *
 * @private
 * @param {number} timeoutSec seconds before run timeoutAction
 * @param {function} timeoutAction function that will called at timeout
 */
com.inq.flash.client.chatskins.SkinControl.initializeTimerTimeout = function (timeoutSec, timeoutAction) {
    try {
        if (!timeoutSec) {
            /*  No time out if timeoutSec is not set */
            haxe.Log.trace("Timeout value was not set. Timeout will not occur.");
            return;
        } else {
            var maxTimeOut = Math.pow(2,32) - 1;
            /* isNaN check should come first or it always return false */
            if (isNaN(timeoutSec) || timeoutSec < 0 || timeoutSec > maxTimeOut) {
                haxe.Log.trace(
                    "Default time out is used if timeoutSec is negative, it is bigger than maxTimeOut, or it is a NaN"
                );
				timeoutSec = com.inq.flash.client.control.FlashPeer.getInitialTimeout();
            }
            com.inq.flash.client.chatskins.SkinControl.timerTimeout =
                new com.inq.utils.Timer(timeoutSec * com.inq.flash.client.chatskins.SkinControl.SEC);

			// Warn customers that the chat will be closed in 30 sec.
            com.inq.flash.client.chatskins.SkinControl.startWarning(timeoutSec);
		}
	} catch( msg ) {
		if( js.Boot.__instanceof(msg,String) ) {
            haxe.Log.trace("An error occured with timeoutSec. Setting to default of two minutes");
			timeoutSec = com.inq.flash.client.control.FlashPeer.getInitialTimeout();
            com.inq.flash.client.chatskins.SkinControl.timerTimeout =
                new com.inq.utils.Timer(timeoutSec * com.inq.flash.client.chatskins.SkinControl.SEC);
		} else throw(msg);
	}
    // Set timer run function
    com.inq.flash.client.chatskins.SkinControl.timerTimeout.run = timeoutAction;
    // Save parameters of run
    com.inq.flash.client.chatskins.SkinControl.timeoutTime = timeoutSec;
    com.inq.flash.client.chatskins.SkinControl.timeoutAction = timeoutAction;
};


/**
 * getCallStreamData
 *
 * $type TFun([],TInst(String,[]))
 * public static function getCallStreamData():String
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getCallStreamData = function() {
	/** @type {String} */
	var skinVersion = com.inq.utils.Util.getConfig("skinVersion","0");
	/** @type {Boolean} */
	var utfenable = com.inq.utils.Util.getConfig("utfenable",false);
	/** @type {String} */
	var callStreamDataLocal;
	/** @type {String} */
	var numberLength;
	/** @type {com.inq.ui.TextInput} */
	var callerPhone;
	/** @type {String} */
	var countryCode;
	/** @type {Number} */
	var i;
	/** @type {String} */
	var callerPhoneString = "";
	/** @type {String} */
	var callErrorMessage;
	/*
	 *  Regex to replace all non digits with empty string
	 */
	/** @type {EReg} */
	var myReg = new EReg("[^\\d]","g");
	if (skinVersion == "0") {
		/*  backward compatibility */
		/** @type {String} */
		var phoneSeparator = com.inq.utils.Util.getConfig("phoneSeparator", "-");
		numberLength = com.inq.utils.Util.getConfig("numberLength", "10");
		callStreamDataLocal = "^^";
		callErrorMessage = com.inq.utils.Util.getConfig("phoneErrorMessage", "Please enter a valid phone number consisting of " + numberLength + " digits (or more for numbers with extension)");

		try {
			callerPhone = Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerPhone");
			if (callerPhone == null || StringTools.trim(callerPhone._getInput()) == "") throw callErrorMessage;
			callerPhoneString = StringTools.trim(callerPhone._getInput());
		} catch (msg) {
			try {
				/** @type {com.inq.ui.TextInput} */
				var callerPhoneField1 = Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField1");
				/** @type {com.inq.ui.TextInput} */
				var callerPhoneField2 = Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField2");
				/** @type {com.inq.ui.TextInput} */
				var callerPhoneField3 = Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "phoneField3");

				if (callerPhoneField1 != null && callerPhoneField2 != null && callerPhoneField3 != null) callerPhoneString = StringTools.trim(callerPhoneField1._getInput() + callerPhoneField2._getInput() + callerPhoneField3._getInput());

				if (callerPhoneString == "") throw msg;
			} catch (msg1) {
				throw msg1;
			}
		}
		/*
		 *  Regex to replace all non digits with empty string
		 */
		if(utfenable == false) {
			callerPhoneString = myReg.replace(callerPhoneString,"");
			/*
			 * Regex to check if user input more then 10 digits to make area code plus phone number plus phone extension
			 */
			myReg = new EReg("^\\d{10,}$","");

			if(!myReg.match(callerPhoneString)) throw callErrorMessage;
		}
		if(callerPhoneString.length > 10) callerPhoneString = HxOverrides.substr(callerPhoneString,0,10) + "x" + HxOverrides.substr(callerPhoneString,10,null);
		/* original code was
		 * 	var countryCode:String = untyped Application.application.skinConfig["countryISDCode"]?(Application.application.skinConfig["countryISDCode"]=="0")?"":Application.application.skinConfig["countryISDCode"]+"-":"1-";
		 *	which states:
		 *		if country code does not exist use "1-"
		 * 		else
		 * 			if country code is "0", then use an empty string
		 * 			else use country code appended with a dash.
		 *
		 *    ---------+---------
		 *      config | result
		 *    ---------+---------
		 *    undefined| "1-"
		 *       "0"   | ""
		 *       "1"   | "1-"
		 *     anything| anything-
		 *
		 *
		 * Since we are using getConfig to get the configuration infomation (because it is code compression safe)
		 *   we do the following:
		 */
		countryCode = Std.string(com.inq.utils.Util.getConfig("countryISDCode", "1")) + "-";/* Add separator  */
		if (countryCode == "0-") countryCode = "";

		if (countryCode != "1-") callerPhoneString = countryCode + callerPhoneString; else callerPhoneString = countryCode + HxOverrides.substr(callerPhoneString, 0, 3) + Std.string(phoneSeparator) + HxOverrides.substr(callerPhoneString, 3, 3) + Std.string(phoneSeparator) + HxOverrides.substr(callerPhoneString, 6, null);
		callStreamDataLocal += com.inq.flash.client.chatskins.SkinControl.CSDL_CALLERPHONE + callerPhoneString;
		com.inq.flash.client.chatskins.SkinControl.callerNameString = readCallerName();
		return callStreamDataLocal;
	} else {
		/*  new skin code */
		/** @type {String} */
		var callerPhoneExt = "";
		callStreamDataLocal = "^^";
		numberLength = com.inq.utils.Util.getConfig("numberLength", "10");
		callErrorMessage = com.inq.utils.Util.getConfig("phoneErrorMessage", "Please enter a valid phone number consisting of " + numberLength + " digits (or more for numbers with extension)");
		/** @type {Array} */
		var callerPhones = [];
		/** @type {Array} */
		var callerPhoneStrings = [];

		try {
			i = 1;
			if (Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerPhoneExt") != null) {
				callerPhoneExt = StringTools.trim(Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerPhoneExt").getInput());
			} else {
				callerPhoneExt = "";
			}

			while (Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerPhone" + i)) {
				callerPhones[i - 1] = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerPhone" + i);
				i++;
			}
			if (callerPhones.length == 0) throw callErrorMessage;
			i = 0;
			/** @type {Boolean} */
			var checkValidInput = false;
			while (i < callerPhones.length) {
				if (StringTools.trim(callerPhones[i]._getInput()) == "") checkValidInput = true;
				i++;
			}
			if (checkValidInput == true) throw callErrorMessage;

			i = 0;
			while (i < callerPhones.length) {
				callerPhoneStrings[i] = callerPhones[i]._getInput();
				if (utfenable == false) {
					myReg = new EReg("[^\\d]","g");
					callerPhoneStrings[i] = myReg.replace(callerPhoneStrings[i], "");
					myReg = new EReg("^\\d{" + callerPhoneStrings[i].length + ",}$", "");
					if (!myReg.match(callerPhoneStrings[i])) throw callErrorMessage;
				}
				i++;
			}

			for (i = 0; i < callerPhoneStrings.length; i++) {
				callerPhoneString += StringTools.trim(callerPhoneStrings[i]);
			}


			if (callerPhoneString.length < Std.parseInt(numberLength)) throw callErrorMessage;
		} catch (msg) {
			throw msg;
		}
		/** @type {?String} */
		var checkforhyphen = com.inq.utils.Util.getConfig("phoneSeparator", null);
		if (checkforhyphen != null) {
			/** @type {String} */
			var tempStr = callerPhoneString;
			/** @type {Number} */
			var val1;
			/** @type {Number} */
			var val2 = 0;
			i = 0;
			while (i < callerPhoneStrings.length - 1) {
				val1 = 0;
				val2 += callerPhoneStrings[i].length + i;
				tempStr = HxOverrides.substr(tempStr, val1, val2) + Std.string(checkforhyphen) + HxOverrides.substr(tempStr, val2, null);
				i++;
			}
			callerPhoneString = tempStr;
		}

		countryCode = com.inq.utils.Util.getConfig("countryISDCode", "1");
		countryCode = countryCode == "0" ? "" : countryCode + "-";
		callerPhoneString = countryCode + callerPhoneString;

		if (callerPhoneExt != "") callerPhoneString += "x" + callerPhoneExt;

		callStreamDataLocal += com.inq.flash.client.chatskins.SkinControl.CSDL_CALLERPHONE + callerPhoneString;
		com.inq.flash.client.chatskins.SkinControl.callerNameString = readCallerName();
		return callStreamDataLocal;
	}
};

/**
 * Read caller name from c2call form.
 * @returns {String} - caller name which supports only letters, "-" sign and single space between words,
 * all unsupported characters are replaced by spaces.
 */
function readCallerName() {
	/** @type {com.inq.ui.TextInput} */
	var callerName = Application.application.getTextInput(com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE + "callerName");
	/** @type {String} */
	var callerNameString = StringTools.trim(callerName._getInput());

	/** @type {EReg} */
	var myReg = new EReg("(?=[\\d\\0\\n\\f\\r\\t\\v])(?=[^-])","g");
	callerNameString = myReg.replace(callerNameString," ");

	myReg = new EReg("\\s+","g");
	callerNameString = myReg.replace(callerNameString," ");

	myReg = new EReg("\\s+-|-\\s+","g");
	return myReg.replace(callerNameString,"-");
}

/**
 * getCallFormData
 *
 * $type TFun([],TInst(String,[]))
 * public static function getCallFormData():String
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getCallFormData = function() {
	/** @type {String} */
	var skinVersion = com.inq.utils.Util.getConfig("skinVersion","0");
	/** @type {NodeList} */
	var divElements;
	/** @type {string} */
	var formString;
	/** @type {EReg} */
	var myReg;
	/** @type {com.inq.ui.TextInput} */
	var fieldToGet;
	if(skinVersion == "0") {
		/*  backward compatibility */
		formString = "";
		try {
			divElements = document.getElementById('btnCall').parentNode.getElementsByTagName('DIV');
			for (var j = 0, l = divElements.length; j < l; j++) {
				try {
					myReg = new EReg("^" + com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE,"");
					/*
					 * Check to see if string starts with proper prepended string to submit
					 */
					if (!myReg.match(divElements[j].id) ||
						StringTools.endsWith(divElements[j].id, "callerPhone") ||
						StringTools.endsWith(divElements[j].id, "phoneField1") ||
						StringTools.endsWith(divElements[j].id, "phoneField2") ||
						StringTools.endsWith(divElements[j].id, "phoneField3") ||
						StringTools.endsWith(divElements[j].id, "callerName")) {
						continue;
					}

					fieldToGet = Application.application.getTextInput(divElements[j].id);

					formString += "^^_" + myReg.matchedRight() + "=" + myReg.matchedRight() + "^^" + myReg.matchedRight() + "=" + StringTools.trim(fieldToGet._getInput());
				} catch( e ) {
					if( js.Boot.__instanceof(e,Error) ) {
						haxe.Log.trace("Error type for ," + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2087, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "getCallFormData"});
					} else throw(e);
				}
			}
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				haxe.Log.trace("HtmlPersistentButton: show button failed," + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2091, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "getCallFormData"});
			} else throw(e);
		}
		return formString;
	} else {
		/*  new code for new skin */
		formString = "";
		try {
			var /** @type {number} */ i = 1;
			divElements = document.getElementById('btnCall').parentNode.getElementsByTagName('DIV');
			var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = divElements.length;
			while(_g1 < _g) {
				var /** @type {number} */ divIndex = _g1++;
				try {
					myReg = new EReg("^" + com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE,"");
					/*
					 * Check to see if string starts with proper prepended string to submit
					 */
					if(!myReg.match(divElements[divIndex].id) || StringTools.endsWith(divElements[divIndex].id,"callerPhoneExt") || StringTools.endsWith(divElements[divIndex].id,"callerName")) continue;

					if(StringTools.endsWith(divElements[divIndex].id,"callerPhone" + i)) {
						i++;
						continue;
					}

					fieldToGet = Application.application.getTextInput(divElements[divIndex].id);

					formString += "^^_" + myReg.matchedRight() + "=" + myReg.matchedRight() + "^^" + myReg.matchedRight() + "=" + StringTools.trim(fieldToGet._getInput());
				} catch( e ) {
					if( js.Boot.__instanceof(e,Error) ) {
						haxe.Log.trace("Error type for ," + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2123, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "getCallFormData"});
					} else throw(e);
				}
			}
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				haxe.Log.trace("HtmlPersistentButton: show button failed," + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2127, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "getCallFormData"});
			} else throw(e);
		}
		return formString;
	}
};

/**
 * getInitialClickstreamData
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getInitialClickstreamData = function() {
	var streamBuilder = com.inq.flash.client.control.ClickStreamBuilder;
	/** @type {String} */
	var sInitialClickstreamData = streamBuilder.parseInitialClickstreamData()
		+ streamBuilder.IdentifyPlatform()
		+ streamBuilder.parseURLfromClickStreamData()
		+ streamBuilder.parseDFVfromClickStreamData()
		+ com.inq.flash.client.chatskins.SkinControl.callStreamData
		+ com.inq.flash.client.chatskins.SkinControl.addWebRTCToStream();

	return sInitialClickstreamData;
};

/**
 * getChatWindow
 * getter for the chat text area
 *
 * $type TFun([],TInst(com.inq.flash.client.chatskins.ChatTextArea,[]))
 * public static function getChatWindow():ChatTextArea
 * @public
 * @static
 * @return {com.inq.flash.client.chatskins.ChatTextArea} - the instance of the chat text area
 */
com.inq.flash.client.chatskins.SkinControl.getChatWindow = function() {
	return com.inq.flash.client.chatskins.SkinControl.cw;
};


/**
 * updateFormFields
 *
 * $type TFun([{ name => formData, t => TInst(String,[]), opt => false },{ name => formName, t => TInst(String,[]), opt => false },{ name => formId, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function updateFormFields(formData:String, formName:String, formId:String )
 * @public
 * @static
 * @param {string}  formData
 * @param {string}  formName
 * @param {string}  formId
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.updateFormFields = function(formData,formName,formId) {
	com.inq.flash.client.chatskins.FormMgr.updateFormFields(formData,formName,formId,com.inq.flash.client.chatskins.SkinControl.cw);
};


/**
 * getInputArea
 * get customer's input area
 *
 * $type TFun([],TInst(com.inq.ui.TextInput,[]))
 * @public
 * @static
 * @return {com.inq.ui.TextInput}
 */
com.inq.flash.client.chatskins.SkinControl.getInputArea = function() {
	return Application.application.getMxmlItem("txtInput");
};


/**
 * disableInput
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function disableInput():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.disableInput = function() {
	/** @type {com.inq.ui.TextInput} */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if (com.inq.utils.Capabilities.isPhone()) {
		/* If we close the chat from the agent, we must also
		 * * Blur the input field so the virtual keyboard retracts
		 * * Call the onBlur handler directly.  This must be done because we have closed the "ChatTextFocusMonitor" and we are no longer listening for the blur event
		 */
		ti.blur();
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.onBlur(null);
	}
	ti.clearPlaceholder();
	ti._setInput("");
	ti._enable(true);
	ti.setVisible(false);

	/** @type {com.inq.ui.Button} */
	var btn = com.inq.flash.client.chatskins.SkinControl.getSendButton();
	if (btn) {
		btn.disable();
	}
};


/**
 * sendDisableInput
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function sendDisableInput():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.sendDisableInput = function() {
	com.inq.flash.client.chatskins.SkinControl.disableInput();
};

/**
 * noUnload - Special code for unloading persistent chat when transfering to new domain
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function noUnload():Void
 * @public
 * @static
 * @author fpinn
 * @return {void} - void
 */
com.inq.flash.client.chatskins.SkinControl.noUnload = function() {
	window.onunload = function(ev) {
		return true;
	};
};


/**
 * kickOffChat - starts the chat openers or automatons when non-visible window becomes visible
 *
 * $type TFun([{ name => noOpeners, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * public static function kickOffChat(?noOpeners:Bool=false)
 * @public
 * @static
 * @param {boolean}  noOpeners
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.kickOffChat = function(noOpeners) {
	if(noOpeners == null) noOpeners = false;
	if(com.inq.flash.client.chatskins.SkinControl.bChatIsVisible){
		return;
	}
	com.inq.flash.client.chatskins.SkinControl.bChatIsVisible = true;
	if(com.inq.flash.client.chatskins.SkinControl.chatContainer != null) com.inq.flash.client.chatskins.SkinControl.chatContainer.setEnabled(true);
	if(com.inq.flash.client.chatskins.SkinControl.autoAgent == null || com.inq.flash.client.chatskins.SkinControl.autoAgent.getVisible() == false) try {
		if(!noOpeners) com.inq.flash.client.chatskins.SkinControl.openerScript.start();
		/** @type {com.inq.ui.TextInput} */
		var txtInput = Application.application.getTextInput("txtInput");
		if(txtInput != null) txtInput.setFocus();
	} catch( e ) {
	} else
		try {
			com.inq.flash.client.chatskins.SkinControl.InitializeAutomoton();
		} catch( e ) {
		}
};


/**
 * onChatEngaged
 * Focuses input field and stops openers.
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function onChatEngaged():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.onChatEngaged = function() {
	com.inq.flash.client.chatskins.SkinControl.stopOpenerScript(true);
	com.inq.flash.client.chatskins.SkinControl.StopTimer();
    if (Application.setFocusToBtnCloseOnOpen) {
        /*RTDEV-19956 - the close button is not in focus when there is a pre-chat survey involved*/
        com.inq.flash.client.chatskins.SkinControl.setFocusOnCloseButton();
    } else {
        com.inq.flash.client.chatskins.SkinControl.setFocusOnInputField(true);
    }
};


/**
 * persistentChatInitialize
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function persistentChatInitialize()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.persistentChatInitialize = function() {
	try {
		/* an unload of the window is an implied close */
		window.onload = function(ev) {
			return true;
		};
		window.onunload = function(ev) {
			com.inq.flash.client.control.FlashPeer.closePersistent(com.inq.flash.client.chatskins.SkinControl.applicationController.isConnected());
			Application.application.close();
			return true;
		};
		try {
			com.inq.flash.client.control.FlashPeer.closePopupChatFromPersistent();
			/* TODO: remove code duplication with CHM.onDataReady in following part:
			 * if (this.isPersistentWindow()) {
			 *     this.setPersistentWindowActive(true);
			 * }
			 */
			com.inq.flash.client.control.FlashPeer.setPersistentWindowActive(true);
		} catch( e ) {
		}

		/** @type {com.inq.ui.Button} */
		var btnCloseChat = com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCloseChat") ? Application.application.getButton("btnCloseChat") : null;
		/** @type {com.inq.ui.Button} */
		var btnPopOut = com.inq.flash.client.chatskins.SkinControl.isInApplication("btnPopOut") ? Application.application.getButton("btnPopOut") : null;
		/** @type {com.inq.ui.Button} */
		var btnPopIn = com.inq.flash.client.chatskins.SkinControl.isInApplication("btnPopIn") ? Application.application.getButton("btnPopIn") : null;

		/* If there has been no interaction with an agent, and we are not click2call then set timeout */
		if (com.inq.flash.client.chatskins.SkinControl.applicationController.msgcntAtEntry == 0
			&& !com.inq.flash.client.chatskins.SkinControl.isClick2call()
			&& !com.inq.flash.client.chatskins.SkinControl.isClick2WebCall()
		) {
			var initialTimeOutSec = com.inq.flash.client.chatskins.SkinControl.getInitialTimeout();
            com.inq.flash.client.chatskins.SkinControl.startTimer(initialTimeOutSec);
		}

		if(btnCloseChat != null && btnPopIn == null) btnCloseChat.setVisible(true);
		if(btnPopOut != null) btnPopOut.setVisible(false);
		if(btnPopIn != null) btnPopIn.setVisible(true);
	} catch( e ) {
			haxe.Log.trace("error" + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2295, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "persistentChatInitialize"});
	}
	try {
		if(com.inq.flash.client.chatskins.SkinControl.isClick2call()) {
			/** @type {com.inq.ui.Canvas} */
			var chatCanvas = Application.application.getCanvas("callForm");
			chatCanvas.setVisible(false);
			chatCanvas = Application.application.getCanvas("callFormPersistent");
			chatCanvas.setVisible(true);
		}
	} catch( e ) {
			haxe.Log.trace("error" + Std.string(e),{ fileName : "SkinControl.hx", lineNumber : 2306, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "persistentChatInitialize"});
	}
};


/**
 * blockService
 *
 * $type TFun([{ name => blockDetails, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public static function blockService(blockDetails:String):Void
 * @public
 * @static
 * @param {string}  blockDetails
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.blockService = function(blockDetails) {
	com.inq.flash.client.control.FlashPeer.blockService(blockDetails);
};


/**
 * wasSaleAction
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function wasSaleAction():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.wasSaleAction = function() {
	return com.inq.flash.client.control.FlashPeer.wasSaleAction();
};


/**
 * executeCustomCommand
 *
 * $type TFun([{ name => commandParam, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @static
 * @param {string}  commandParam
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.executeCustomCommand = function(commandParam) {
	return com.inq.flash.client.control.FlashPeer.executeCustomCommand(commandParam);
};


/**
 * getScriptLine
 *
 * $type TFun([{ name => index, t => TInst(Int,[]), opt => false }],TInst(String,[]))
 * public static function getScriptLine( index:Int ):String
 * @public
 * @static
 * @param {number}  index
 * @return {string}
 */
com.inq.flash.client.chatskins.SkinControl.getScriptLine = function(index) {
	return com.inq.flash.client.chatskins.SkinControl.cw.getTranscriptMessage(index);
};


/**
 * getSendButton
 * get Send button
 *
 * $type TFun([],TInst(com.inq.ui.Button,[]))
 * public static function getSendButton():Button
 * @public
 * @static
 * @return {com.inq.ui.Button}
 */
com.inq.flash.client.chatskins.SkinControl.getSendButton = function() {
	return Application.application.getButton("btnSend");
};


/**
 * hideInput
 * hide customer's input text and send button
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function hideInput():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.hideInput = function() {
	com.inq.flash.client.chatskins.SkinControl.disableInput();
	com.inq.flash.client.chatskins.SkinControl.showBottomImgWithoutInput(true);
};


/**
 * showInput
 * show customer's input text and send button
 *
 * public static function showInput(showIntroduction:Bool):Void
 * @public
 * @static
 * @param {boolean=} showIntroduction
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.showInput = function(showIntroduction) {
	/** @type {com.inq.ui.Button} */
	var button = com.inq.flash.client.chatskins.SkinControl.getSendButton();
	if (button != null) {
		button.enable();
	}
	/** @type {com.inq.ui.TextInput} */
	var ti = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if(ti != null) {
		ti._enable(false);
		/** @type {number}*/
		var msgCount = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);
		if (showIntroduction && msgCount == 0) {
			ti.setIntroduction();
		} else {
			ti.restorePreviousValue();
		}
		ti.setVisible(true);
	}
	com.inq.flash.client.chatskins.SkinControl.showBottomImgWithoutInput(false);
};


/**
 * showBottomImgWithoutInput
 * show/hide additional images without input, hide/show original images
 * if there is no additional images, then original images don't hide.
 *
 * $type TFun([{ name => isShow, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public static function showBottomImgWithoutInput(isShow:Bool):Void
 * @public
 * @static
 * @param {boolean}  isShow -  if true, then show imgs without input, hide original img
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.showBottomImgWithoutInput = function(isShow) {
	/** @type {com.inq.ui.Container} */
	var chatWin = Application.application.getCanvas("chat");
	if(chatWin == null) return;
	/* untyped alert("can't find chat win"); */
	/*  show/hide middle image */
	/** @type {Object} */
	var middleHidden = chatWin.findChild("bottomMiddleHiddenInput");
	if(middleHidden) {
		middleHidden.setVisible(isShow);
		/*  hide/show original img */
		/** @type {Object} */
		var middle = chatWin.findChild("bottomMiddle");
		if(middle) middle.setVisible(!isShow);
	}

	/*  show/hide left image */
	/** @type {Object} */
	var leftHidden = chatWin.findChild("bottomLeftHiddenInput");
	if(leftHidden) {
		leftHidden.setVisible(isShow);
		/*  hide/show original img */
		/** @type {?Object} */
		var left = chatWin.findChild("bottomLeft");
		if(left) left.setVisible(!isShow);
	}

	/*  show/hide right image */
	/** @type {Object} */
	var rightHidden = chatWin.findChild("bottomRightHiddenInput");
	if(rightHidden) {
		rightHidden.setVisible(isShow);
		/*  hide/show original img */
		/** @type {Object} */
		var right = chatWin.findChild("bottomRight");
		if(right) right.setVisible(!isShow);
	}
};


/**
 * executeAfter() provides generic way to do some work after some condition is satisfied
 * (e.g. there is no "outstanding messages", or "element exists in DOM").
 *
 * $type TFun([{ name => condition, t => TFun([],TEnum(Bool,[])), opt => false },{ name => handler, t => TFun([],TEnum(Void,[])), opt => false },{ name => contextLocation, t => TInst(String,[]), opt => true },{ name => timeout, t => TInst(Int,[]), opt => true },{ name => cleanupHandler, t => TFun([],TEnum(Void,[])), opt => true }],TEnum(Void,[]))
 * public static function executeAfter(condition:Void -> Bool, handler:Void -> Void, ?contextLocation:String="executeAfter", ?timeout:Int=2000, ?cleanupHandler:Void -> Void)
 * @public
 * @static
 * @param {TFun([],TEnum(Bool,[]))}  condition - predicate, it could be executed many times, when it returns true, then handler is executed
 * @param {TFun([],TEnum(Void,[]))}  handler - code to execute when condition is satisfied
 * @param {string}  contextLocation
 * @param {number}  timeout
 * @param {TFun([],TEnum(Void,[]))}  cleanupHandler
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.executeAfter = function(condition,handler,contextLocation,timeout,cleanupHandler) {
	if(timeout == null) timeout = 2000;
	if(contextLocation == null) contextLocation = "executeAfter";
	if(condition()) {
		haxe.Log.trace(contextLocation + ": executing since condition is satisfied",{ fileName : "SkinControl.hx", lineNumber : 2418, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "executeAfter"});
		handler();
		if(cleanupHandler != null) cleanupHandler();
	} else if(timeout <= 0) {
		haxe.Log.trace(contextLocation + ": executing by timeout",{ fileName : "SkinControl.hx", lineNumber : 2422, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "executeAfter", customParams : ["error"]});
		handler();
		if(cleanupHandler != null) cleanupHandler();
	} else {
		haxe.Log.trace(contextLocation + ": waiting " + timeout + "ms for condition to be satisfied",{ fileName : "SkinControl.hx", lineNumber : 2426, className : "com.inq.flash.client.chatskins.SkinControl", methodName : "executeAfter"});
		com.inq.utils.Timer.delay(function() {
			com.inq.flash.client.chatskins.SkinControl.executeAfter(condition,handler,contextLocation,timeout - 100,cleanupHandler);
		},100);
	}
};

/**
 * MOB-822: This function hides the chatDiv if in case prechat survey
 * or guide is rendered above the chat div
 * @return {Boolean}
 */
com.inq.flash.client.chatskins.SkinControl.hideObscuredChatDiv = function (isChatRestored, txtEL) {
	/**
	 * This should not be called once the chat is engaged
	 */
	var pm = com.inq.flash.client.control.PersistenceManager;
	if (isChatRestored
		|| pm.GetValue(MESSAGE_COUNT, 0) > 0
		|| (com.inq.utils.Capabilities.isPhone()
			&& /Firefox|FxiOS/.test(navigator.userAgent)
		)
	) {
		return txtEL._input.offsetParent === null;
	}
	var application = Application.application;
	var chat = application.getCanvas("Chat") || application.getCanvas("chat");
	if(com.inq.flash.client.control.FlashPeer.isAutoFixPrechatSurvey() && chat && chat.getVisible()) {

		var chatDiv = chat._div;
		var cRect = chatDiv.getBoundingClientRect();
		var el = chatDiv.nextSibling;
		if(!el || !window.getComputedStyle )
			return false;

		do
		{
			var id = el.id.substr("tcChat_".length);
			if(el.nodeType == 1 && application.getMxmlItem(id) && js.Boot.isClass(application.getMxmlItem(id).constructor).indexOf("XFrame")!=-1) {
				var sibRect = el.getBoundingClientRect();
				if(el.style["position"]=="absolute" && el.style["z-index"]==chatDiv.style['z-index'] && window.getComputedStyle(el).visibility!=="none"
					&& sibRect.right>cRect.left && sibRect.bottom>cRect.top && sibRect.left<cRect.right && sibRect.top<cRect.bottom) {
					com.inq.flash.client.chatskins.SkinControl.getInputArea().setVisible(false);
					com.inq.flash.client.chatskins.SkinControl.getSendButton().setVisible(false);
					var cWindow = com.inq.ui.Container._getElementById("tcChat_chatWindow",parent.document);
					cWindow.setAttribute("aria-hidden",true);
					cWindow.setAttribute("data-disabled",true);
					return true;
				}
			}
		}
		while ((el=el.nextSibling) != null);
	}

	return false;
};

/**
 * Sends "exit.chat" message.
 * @see com.inq.flash.client.chatskins.SkinControl.customerClosedChat
 * @param {?function} customerClosedChat - see the SkinControl.customerClosedChat function
 * @param {string} callerName
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.sendExitMsg = function(customerClosedChat, callerName) {
	if (com.inq.flash.client.chatskins.SkinControl.applicationController.customerClosesPopup()) {
		com.inq.flash.client.chatskins.SkinControl.applicationController.sendChatExitMsg(customerClosedChat, callerName);
	} else {
		if (typeof customerClosedChat === "function") {
			customerClosedChat();
		}

		var errorMessage = "SkinControl.sendExitMsg: Not sending CHAT.EXIT message, applicationController.customerClosesPopup === " + com.inq.flash.client.chatskins.SkinControl.applicationController.customerClosesPopup();
		com.inq.flash.client.control.FlashPeer.logError(errorMessage, new Error(errorMessage));
	}
};

com.inq.flash.client.chatskins.SkinControl.cleanUp = function (){
	com.inq.flash.client.chatskins.SkinControl.cw = null;
	com.inq.flash.client.chatskins.SkinControl.objHasFocus = null;
	if(com.inq.utils.Capabilities.isChrome()) {
		com.inq.utils.Capabilities.UnbindListener(window,"beforeunload",com.inq.flash.client.chatskins.SkinControl.unloadHandler);
	} else {
        com.inq.flash.client.chatskins.SkinControl.unloadHandler && com.inq.utils.Capabilities.UnbindListener(window,"unload",com.inq.flash.client.chatskins.SkinControl.unloadHandler);
	}
	com.inq.flash.client.chatskins.SkinControl.chatContainer = null;
	com.inq.flash.client.chatskins.SkinControl.textInput = null;
	com.inq.flash.client.chatskins.SkinControl.autoAgent = null;
	clearInterval(com.inq.flash.client.chatskins.SkinControl.warningEvery2minId);
	com.inq.flash.client.chatskins.SkinControl.accessibilityHelp = null;

};

/**
 * Preparing of SkinControl to the closing of chat.
 */
com.inq.flash.client.chatskins.SkinControl.closeChatSession = function() {
	var appController = com.inq.flash.client.chatskins.SkinControl.getApplicationController();
	if (!com.inq.flash.client.chatskins.SkinControl.chatSessionEnded) {
		com.inq.flash.client.chatskins.SkinControl.chatSessionEnded = true;
		var chatID = appController.getChat().getChatID();
		com.inq.flash.client.control.FlashPeer.endChatSession(chatID);
	}
	/** @deprecated */
	appController.getMessageHandlerByPrefix(com.inq.flash.client.data.MessageFields.TYPE_CHAT_NEED_WAIT).clearQueueMessageTimer();
};

/**
 * Return states of the chat session
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isChatSessionEnded = function () {
	return com.inq.flash.client.chatskins.SkinControl.chatSessionEnded;
};

/**
 * Init the class instance.
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.init = function () {
	// When Thank You Image is enabled then it's marked as shown after each chat session.
	com.inq.flash.client.chatskins.SkinControl.isThankYouShown = false;

	// reset, otherwise openerScript can be missed. RTDEV-13924, Scenario 1
	com.inq.flash.client.chatskins.SkinControl.msgcntAtEntry = com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT, 0);

	if (com.inq.flash.client.chatskins.SkinControl.accessibilityHelp) {
		com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.reset();
	} else {
		com.inq.flash.client.chatskins.SkinControl.accessibilityHelp = com.inq.flash.client.chatskins.AccessibilityHelp.createInstance();
	}

};

com.inq.flash.client.chatskins.SkinControl.getTitleBarHeight = function() {
	return com.inq.utils.Util.getConfig("titleBarImageHeight") || com.inq.flash.client.control.FlashPeer.getTitleBarHeight();
};

com.inq.flash.client.chatskins.SkinControl.getSkinLocation = function() {
	return com.inq.utils.Util.getConfig("flashPos") || com.inq.flash.client.control.FlashPeer.getSkinLocation();
};

com.inq.flash.client.chatskins.SkinControl.getSkinHeight = function() {
	return com.inq.utils.Util.getConfig("flashDimHeight") || com.inq.flash.client.control.FlashPeer.getSkinHeight();
};

com.inq.flash.client.chatskins.SkinControl.getSkinWidth = function() {
	return com.inq.utils.Util.getConfig("flashDimWidth") || com.inq.flash.client.control.FlashPeer.getSkinWidth();
};

com.inq.flash.client.chatskins.SkinControl.getSkinLeft = function() {
	return com.inq.utils.Util.getConfig("flashPosX") || com.inq.flash.client.control.FlashPeer.getSkinLeft();
};

com.inq.flash.client.chatskins.SkinControl.getSkinTop = function() {
	return com.inq.utils.Util.getConfig("flashPosY") || com.inq.flash.client.control.FlashPeer.getSkinTop();
};

com.inq.flash.client.chatskins.SkinControl.getPersistentXPos = function() {
	return com.inq.utils.Util.getConfig("persistentXPos") || com.inq.flash.client.control.FlashPeer.getPersistentXPos();
};

com.inq.flash.client.chatskins.SkinControl.getPersistentYPos = function() {
	return com.inq.utils.Util.getConfig("persistentYPos") || com.inq.flash.client.control.FlashPeer.getPersistentYPos();
};

com.inq.flash.client.chatskins.SkinControl.getPersistentWidth = function() {
	return com.inq.utils.Util.getConfig("persistentWidth") || com.inq.flash.client.control.FlashPeer.getPersistentWidth();
};

com.inq.flash.client.chatskins.SkinControl.getPersistentHeight = function() {
	return com.inq.utils.Util.getConfig("persistentHeight") || com.inq.flash.client.control.FlashPeer.getPersistentHeight();
};

/**
 * Returns value to detect state of autofocus on 'txtInput' element
 * @return {boolean}
 */
com.inq.flash.client.chatskins.SkinControl.isTxtInputAutofocusBlocked = function () {
	return com.inq.utils.Util.getConfig("blockTxtInputAutofocus", false);
};

com.inq.flash.client.chatskins.SkinControl.fireCustomEvent = function (eventName, evtDataSupplementFcn) {
	if (eventName == "PrechatSurveyShown") {
		if (com.inq.flash.client.control.PersistenceManager.GetValue(PRE_CHAT_SURVEY_SHOWN) == 1) {
			return;
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(PRE_CHAT_SURVEY_SHOWN, 1);
	} else if (eventName == "PrechatSurveyCompleted") {
		if (com.inq.flash.client.control.PersistenceManager.GetValue(PRE_CHAT_SURVEY_COMPLETED) == 1) {
			return;
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(PRE_CHAT_SURVEY_COMPLETED, 1);
	}
	com.inq.flash.client.control.FlashPeer.fireCustomEvent(eventName, null, null, evtDataSupplementFcn);
};

/**
 * Closing remaining persistent chat window.
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.closeParentWindow = function() {
	if (com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		window.parent.close();
	}
};

/**
 * initializePanelHandler:  Initialize the panelHandler object with the initial dimensions and positions
 * RTDEV-22146: Canvas panels should not shift the CI when they open and close
 * @public
 * @static
 * @param {string}  layerID -  id of panel layer that opens or closes
 * @param {boolean}  isOpen -  indicates if the panels are opening or closing
 * @return {object} panelHandler - an object with the panel and chat details
 */
com.inq.flash.client.chatskins.SkinControl.initializePanelHandler = function (layerID, isOpen) {
	if (!com.inq.utils.Util.getConfig("fixChatOnPanelOpenClose", false) || com.inq.utils.Capabilities.isPhone() || com.inq.flash.client.control.FlashPeer.isPersistentWindow()) {
		return null;
	}
	var chatWinObj;
	var pDoc = parent.document;
	if (com.inq.utils.Util.getConfig("divSkin", false)) {
		chatWinObj = com.inq.ui.Container._getElementById("tcChat_Skin",pDoc);// for div chats
	} else {
		chatWinObj = com.inq.ui.Container._getElementById("inqChatStage", pDoc);// for iframe chats
	}
	var panelHandler = {};
	panelHandler.initialWidth = parseInt(chatWinObj.style.width);
	panelHandler.initialHeight = parseInt(chatWinObj.style.height);
	panelHandler.initialLeft = parseInt(chatWinObj.style.left);
	panelHandler.initialTop = parseInt(chatWinObj.style.top);
	if (!isOpen) {
		com.inq.flash.client.chatskins.SkinControl.determinePanelPosition(layerID, panelHandler);
	}
	return panelHandler;
};

/**
 * fixChatOnPanelOpenClose:  Temporarily moves the stage/chat to a new position so that it appears fixed when a panel opens or closes
 * RTDEV-22146: Canvas panels should not shift the CI when they open and close
 *
 * The chat skin shifts only when the panels appears on the left or on the top.
 *
 * This is because when we expand a div by changing the width attribute, the expansion is
 * always towards the right-hand side in html. So, if the panels are on the right,
 * then chat panel remains in place but if the panels are on the left, this moves the chat window to the right.
 *
 * The same is true when we expand a div by changing the height attribute, the expansion is always towards
 * the bottom in a html. So, any panel which is on the top will move the chat window down.
 *
 * The only way to handle this is temporarily move the position (left or top) of the entire chat stage,
 * so that the chat window remains intact. We need to move it back when the panels close
 * @public
 * @static
 * @param {string}  layerID -  id of panel layer that opens
 * @param {boolean}  isOpen -  indicates if the panels are opening or closing
 * @param {object} panelHandler - an object with the panel and chat details
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.fixChatOnPanelOpenClose = function (layerID, isOpen, panelHandler) {
	if (!com.inq.utils.Util.getConfig("fixChatOnPanelOpenClose", false) || com.inq.utils.Capabilities.isPhone() || com.inq.flash.client.control.FlashPeer.isPersistentWindow() || panelHandler == null) {
		return;
	}
	var chatWinObj;
	var pDoc = parent.document;
	if (com.inq.utils.Util.getConfig("divSkin", false)) {
		chatWinObj = com.inq.ui.Container._getElementById("tcChat_Skin",pDoc);// for div chats
	} else {
		chatWinObj = com.inq.ui.Container._getElementById("inqChatStage", pDoc);//for iframe chats
	}
	var deltaWidth = parseInt(chatWinObj.style.width) - panelHandler.initialWidth;
	var deltaHeight = parseInt(chatWinObj.style.height) - panelHandler.initialHeight;
	var newLeft = panelHandler.initialLeft;
	var newTop = panelHandler.initialTop;
	var fixChat = false;

	if (deltaWidth != 0 || deltaHeight != 0) {// proceed only if there is any change in the dimensions
		if (isOpen) {
			com.inq.flash.client.chatskins.SkinControl.determinePanelPosition(layerID, panelHandler);
		}
		if (deltaWidth != 0 && panelHandler.isLeftPanel) {
			newLeft = panelHandler.initialLeft - deltaWidth;
			if (newLeft < 0) {
				newLeft = 0;//the left position should not be negative
			}
			fixChat = true;
		}

		if (deltaHeight != 0) {
			newTop = panelHandler.initialTop - deltaHeight;
			if (newTop < 0) {
				newTop = 0;//the top position should not be negative
			}
			fixChat = true;
		}

		if (fixChat) {
			//Move the iframe as well.
			Application.application.stg.style.left = newLeft + "px";
			Application.application.stg.style.top = newTop + "px";
			Application.MoveSizeDiv2Stage(null, null, newLeft, newTop);
		}
	}
};

/**
 * determinePanelPosition:  Determines if the panel was opened/closed on the left side or top side of the chat.
 * RTDEV-22146: Canvas panels should not shift the CI when they open and close
 * @private
 * @param {string}  layerID -  id of panel layer that opens
 * @param {object} panelHandler - an object with the panel and chat details
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.determinePanelPosition = function (layerID, panelHandler) {

	panelHandler.isLeftPanel = false;
	panelHandler.isTopPanel = false;
	var pDoc = parent.document;
	try {
		var ele = com.inq.ui.Container._getElementById("tcChat_" + layerID,pDoc);
		if (!ele) {
			ele = document.getElementById(layerID);
		}
		var panelObj = ele.getBoundingClientRect();
		var panelLeft = panelObj.left;
		var panelTop = panelObj.top;
		var chatLeft = -1;
		var chatTop = -1;

		if (com.inq.utils.Util.getConfig("divSkin", false)) {
			var chatContainer = Application.application.getCanvas("chat") || Application.application.getCanvas("Chat");
			if (chatContainer) {
				var chatWinObj = chatContainer._div.getBoundingClientRect();
				chatLeft = chatWinObj.left;
				chatTop = chatWinObj.top;
			}
		} else {
			var chatWinObj = com.inq.ui.Container._getElementById("inqChatStage", pDoc);
			chatLeft = parseInt(chatWinObj.style.left);
			chatTop = parseInt(chatWinObj.style.top);
		}

		if (com.inq.utils.Util.getConfig("divSkin", false)) {
			if (chatLeft >= panelLeft) {
				panelHandler.isLeftPanel = true;
			}
			if (chatTop >= panelTop) {
				panelHandler.isTopPanel = true;
			}
		} else {  // for iframe chat, the "getBoundingClientRect" is calculated with respect to the iframe and not the window.
			if (panelLeft < 1) {
				panelHandler.isLeftPanel = true;
			}
			if (panelTop < 1) {
				panelHandler.isTopPanel = true;
			}
		}
	} catch (msg) {
	}
};

/**
 * Stops the propagation of touchmove events for mobile devices
 * so that when we scramble the chat the main page of the site does not move.
 *
 * RTDEV-25723: iOS, Safari: page under chat skin is scrolled when scrolling chat transcript
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.stopScrollPropagation = function(){
	if (com.inq.utils.Capabilities.isPhone() === false) {
		return;
	}

	/** @type {com.inq.ui.Canvas} */
	var chatContainer = Application.application.getCanvas("chat")
						|| Application.application.getCanvas("Chat");
	if (chatContainer) {
		preventTouchMoveEvent(chatContainer._div);
	}

	/** @type {com.inq.ui.Canvas} */
	var chatFooterContainer = Application.application.getCanvas("chatFooter");
	if (chatFooterContainer) {
		preventTouchMoveEvent(chatFooterContainer._div);
	}

	/**
	 * @param {HTMLElement} htmlElement
	 */
	function preventTouchMoveEvent (htmlElement) {
		com.inq.utils.Capabilities.BindListener(htmlElement, "touchmove", function (event) {
			event.preventDefault();
			haxe.Log.trace("Prevented 'touchmove' event", {
				className: 'skinControl',
				methodName: 'stopScrollPropagation'
			});
		});
	}
};

/**
 * Sets agent icon image according to agent type.
 * @param {String} agentType - type of agent which also functions as name of image source
 * Need configuration in skin to enable it
 * <code>
 * agentTypeImageEnabled : true,
 * agentImageConfig : {
 * 		"imageContainerId": "topLeft",
 * 		"virtualAgent": "/VirtualAgent/POP_TL_VA.gif",
 * 		"liveAgent": "/VirtualAgent/POP_TL_LA.gif"
 * 	}
 * </code>
 */
com.inq.flash.client.chatskins.SkinControl.setAgentImage = function(agentType){
	var agentIconImg;
	if (!com.inq.flash.client.chatskins.SkinControl.agentType || com.inq.flash.client.chatskins.SkinControl.agentType !== agentType)
	{
		try {
			agentIconImg = Application.application.getMxmlItem(com.inq.flash.client.chatskins.SkinControl.agentImageConfig["imageContainerId"]);
			agentIconImg._backgroundImage.src = com.inq.ui.SkinLoader.getSkinPath() + com.inq.flash.client.chatskins.SkinControl.agentImageConfig[agentType];
			com.inq.flash.client.chatskins.SkinControl.agentType = agentType;
		} catch (err) {
			haxe.Log.trace("Error while setting Agent type image " + Std.string(e), {
				fileName: "SkinControl.js",
				lineNumber: 4630,
				className: "com.inq.flash.client.chatskins.SkinControl",
				methodName: "setAgentImage"
			});
		}
	}
};

/**
 * InitializeAgentImage
 *
 * Check mxml configuration and set flag to change agent avatar images.
 *
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.SkinControl.InitializeAgentImage = function() {
	com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled = com.inq.utils.Util.getConfig(com.inq.utils.Util.SKIN_CONFIG_KEY_AGENT_IMAGE_ENABLED, false);
	if (com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled === true) {
		com.inq.flash.client.chatskins.SkinControl.agentImageConfig = com.inq.utils.Util.getConfig(com.inq.utils.Util.SKIN_CONFIG_KEY_AGENT_IMAGE_CONFIG, null);
		if (null === com.inq.flash.client.chatskins.SkinControl.agentImageConfig) {
			com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled = false;
		}
	}
};


com.inq.flash.client.chatskins.SkinControl.agentImageConfig = null;
com.inq.flash.client.chatskins.SkinControl.agentImageTypeEnabled = false;
com.inq.flash.client.chatskins.SkinControl.agentType = null;

com.inq.flash.client.chatskins.SkinControl.VIRTUAL_AGENT = "virtualAgent";
com.inq.flash.client.chatskins.SkinControl.LIVE_AGENT = "liveAgent";
com.inq.flash.client.chatskins.SkinControl.VIRTUAL_AGENT_IMAGE_NAME = "virtualAgentImageSrc";
com.inq.flash.client.chatskins.SkinControl.LIVE_AGENT_IMAGE_NAME = "liveAgentImageSrc";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CSDL_CONNECTION = "_ConnectionType=Connection Type^^ConnectionType=";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CSDL_CALLERPHONE = "_CallerPhone=CallerPhone^^CallerPhone=";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CALL_SUBMIT_PRE = "chat_submit_";
/**
 * @type {string}
 */
com.inq.flash.client.chatskins.SkinControl.CSDL_WEBCALLADDRESS = "_WebCall=WebCall^^WebCall=";

/**
 * @type {string}
 */
com.inq.flash.client.chatskins.SkinControl.CSDL_WEBRTC_CAP = "_WebRTCCapable=WebRTCCapable^^WebRTCCapable=";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.callStreamData = "";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.callerNameString = "";

/** @private @type {number} */
com.inq.flash.client.chatskins.SkinControl.customerIndx = 0;

/** @private @type {number} */
com.inq.flash.client.chatskins.SkinControl.hostIndx = 0;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.click2call = false;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.SEC = 1000;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.MIN = 60 * com.inq.flash.client.chatskins.SkinControl.SEC;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.HOUR = 60 * com.inq.flash.client.chatskins.SkinControl.MIN;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.DAY = 24 * com.inq.flash.client.chatskins.SkinControl.HOUR;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.DEFAULT_POST_CHAT_TIMEOUT_SEC = 60 * 60;  // 1h

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.TIMEOUT_AVOIDANCE_SEC = 30;

/** @private @type {com.inq.utils.Timer} */
com.inq.flash.client.chatskins.SkinControl.timerTimeout = null;

/** @type {number} */
com.inq.flash.client.chatskins.SkinControl.keyCount = 0;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.resizable = true;

/** @private @type {com.inq.ui.Canvas} */
com.inq.flash.client.chatskins.SkinControl.autoAgent = null;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.bInternationalization = true;

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl._htmlText = "";

/** @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.bHaveFocus = false;

/** @type {null} */
com.inq.flash.client.chatskins.SkinControl.objHasFocus = null;

/** @type {com.inq.flash.client.chatskins.OpenerScript} */
com.inq.flash.client.chatskins.SkinControl.openerScript = null;

/** @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.bInitialized = false;

/** @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.bChatIsVisible = false;

/** @private @type {string} */
com.inq.flash.client.chatskins.SkinControl.sSocketIP = null;

/** @type {com.inq.flash.client.chatskins.ChatTextArea} */
com.inq.flash.client.chatskins.SkinControl.cw = null;

/** @private @type {com.inq.ui.TextInput} */
com.inq.flash.client.chatskins.SkinControl.textInput = null;

/** @private @type {number} */
com.inq.flash.client.chatskins.SkinControl.timerForTyping = -1;

/** @private @type {number} */
com.inq.flash.client.chatskins.SkinControl.typingTimeout = 4000;

/** @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.userWasTyping = false;

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.tYImageLabel = "";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.DEFAULT_TY_IMAGE_LABEL = "Thank you. Close this window.";

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.bPersistBtnPressed = false;

/** @private @type {com.inq.ui.Container} */
com.inq.flash.client.chatskins.SkinControl.chatContainer = null;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.isThankYou = false ;

/** @private @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.isThankYouShown = false ;

/** @type {boolean} */
com.inq.flash.client.chatskins.SkinControl.typeActivityMessageInProgress = false;

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.customerTypedText = "";

/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_NOT_AUTHORIZED = "1";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_AUTOMATON = "2";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_DENIED = "3";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CUSTOMER_CLOSED = "4";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_EXIT = "5";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CLIENT_COMMAND = "6";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_DO_EXIT = "7";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CONNECTION_LOST = "8";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CMSDKDMH = "9";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_CMSDEXIT = "10";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_ONRELEASE = "11";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_KILLPOPUP = "12";
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.CLOSE_CHAT_REASON_UNKNOWN = "0";

/** @type {RegExp} */
com.inq.flash.client.chatskins.SkinControl.NATIVE_POST_CHAT_SURVEY_REGEXP = /(?:launchNativePostChatSurvey)/;
/** @type {string} */
com.inq.flash.client.chatskins.SkinControl.DATA_SURVEY_URL = "data-survey-url";
